import type { Translation } from '../i18n-types';
import baseLanguageValues from '../en-US';

export const translationValues: Partial<Translation> = {
    SHEETS: 'Listy',
    DASHBOARDS: 'Dashboardy',
    DATABASE_TABLE: 'Databázová tabulka',
    VARIABLES: 'Proměnné',
    FILES: 'Soubory',
    APPS: 'Aplikace',
    LABEL: 'Štítek',
    EDIT_TYPE: 'Typ úpravy',
    EDITING_ROW: 'Úprava řádku {label}',
    CREATE_NEW_ROW: 'Vytvořit nový řádek',
    ADD: 'Přidat',
    MULTIPLY: 'Násobit',
    SET: 'Nastavit',
    PERCENT_CHANGE: 'Procentuální změna',
    NAME: 'Název',
    NAME_AND_STYLE: 'Název a styl',
    PATH: 'Cesta',
    SHARE_WITH: 'Sdílet s',
    SUBMIT: 'Odeslat',
    EDIT: 'Upravit',
    ANY: 'Jakýkoli',
    VIEW: 'Zobrazit',
    EDITING: 'Úprava',
    DUPLICATE: 'Duplikovat',
    DUPLICATE_SHEET_LOADING: 'Duplikování sheetu...',
    DUPLICATE_SHEET_SUCCESS: 'Tabulka byla úspěšně duplikována',
    DUPLICATE_SHEET_ERROR: 'Chyba při duplikaci sheetu',
    DUPLICATE_FOLDER_LOADING: 'Duplikování složky...',
    DUPLICATE_FOLDER_SUCCESS: 'Složka byla úspěšně duplikována',
    DUPLICATE_FOLDER_ERROR: 'Chyba při duplikaci složky',
    DELETE_TILE: 'Smazat dlaždici',
    MATCH_CASE: 'Rozlišovat velká/malá písmena',
    SEARCH: 'Hledat',
    SEARCH_VALUES: 'Hledat hodnoty',
    IMPORT: 'Importovat',
    MODEL_HEALTH: 'Zdraví modelu',
    CHECKLIST: 'Kontrolní seznam',
    DYNAMIC_ANALYSIS: 'Dynamická analýza',
    STATIC_ANALYSIS: 'Statická analýza',
    CALCULATION_LOGS: 'Protokoly výpočtů',
    ERROR_MESSAGE: 'Chybová zpráva',
    CALCULATION_TIME_MS: 'Doba výpočtu (ms)',
    ERRORS: 'Chyby',
    WARNINGS: 'Varování',
    AMPLIFICATION_FACTOR: 'Faktor zesílení',
    CELL_COUNT_ESTIMATE: 'Počet buněk (odhad)',
    NO_CALCULATION_ERRORS: 'Žádné chyby výpočtu',
    CALCULATION_ERRORS: 'Nalezeny chyby výpočtu',
    NO_MODELLING_ERRORS: 'Žádné chyby modelování',
    MODELLING_ERRORS: 'Nalezeny chyby modelování',
    MODEL_FULLY_LOADED: 'Model je plně načten',
    MODEL_NOT_LOADED: 'Model není načten',
    SHARING: 'Sdílení',
    ASSIGNMENT: 'Úkol',
    ASSIGNMENTS: 'Úkoly',
    LOAD_MORE: 'Načíst další',
    SHARES: 'Akcie',
    SHARE: 'Sdílet',
    OPEN: 'Otevřít',
    NONE: 'Žádný',
    TABLE: 'Tabulka',
    VALUE: 'Hodnota',
    DATE: 'Datum',
    NONE_SELECTED: 'Nic nevybráno',
    VALUE_FOR_MONTH: 'Hodnota pro měsíc',
    DESCRIPTION: 'Popis',
    NOTES: 'Poznámky',
    CUSTOM_FIELD: 'Vlastní pole',
    TABLE_DESCRIPTION: 'Popis tabulky',
    EDIT_COLUMN: 'Upravit sloupec',
    COLUMN_TYPE: 'Typ sloupce',
    MONTH: 'Měsíc',
    VARIABLE_AND_DIMENSIONS: 'Proměnná a dimenze',
    SHOW_UNMAPPED: 'Zobrazit nepřiřazené',
    MANUAL_MAPPING: 'Manuální mapování',
    CLEAR: 'Vyčistit',
    AUTODETECT: 'Automatické detekování',
    FILTER: 'Filtr',
    SELECT_ALL_BRACKETS: '(Vybrat vše)',
    BLANK_CELLS_BRACKETS: '(Prázdné buňky)',
    SELECT_DIMENSIONS: 'Vyberte rozměry',
    CONFIRM: 'Potvrdit',
    REMOVE_ALL_MAPPINGS_CONFIRM: 'Jste si jisti, že chcete odstranit všechna mapování?',
    REMOVE_MANUALLY_ADDED_MAPPING_TAGS: 'Tato akce odstraní všechny ručně přidané značky mapování.',
    ERROR_IMPORTING_FILE: 'Chyba při importu souboru',
    CHOOSE_JOB_TO_REPLACE: 'Vyberte úlohu k nahrazení',
    PREVIOUS_IMPORTS: 'Předchozí importy',
    WELCOME_TO_IMPORT: 'Vítejte u importu.',
    IMPORT_SPREADSHEETS: 'Importujte své tabulky z Excelu přímo do Farseer a spravujte je.',
    DRAG_FILE_HERE: 'Přetáhněte svůj soubor sem',
    BROWSE: 'Procházet',
    IMPORT_MISSING_MEMBERS: 'Importujte chybějící členy',
    IMPORT_VALUES: 'Importovat hodnoty',
    NO_COLUMN_SET_AS_TABLE: 'Žádný sloupec není nastaven jako dimenze',
    NO_COLUMN_SET_AS_VALUE: 'Žádný sloupec není nastaven jako hodnota',
    MISSING_MEMBERS: 'Chybí členové dimenze',
    SELECT_ALL: 'Vybrat vše',
    DESCRIPTION_COLUMN: 'Sloupec s popisem',
    CONNECTED_DIMENSIONS_COLUMN: 'Připojený sloupec rozměrů',
    CANCEL: 'Storno',
    CONTINUE: 'Pokračovat',
    CREATE_DIMENSIONS: 'Vytvořit rozměry',
    SELECT_CONNECTION: 'Vybrat připojení',
    CLOSE: 'Zavřít',
    SAVE: 'Uložit',
    DELETE: 'Smazat',
    REMOVE: 'Odebrat',
    DELETING_ASSIGNMENT: 'Mazání úkolu{multiple} ...',
    DELETED_ASSIGNMENT: 'Úkol {multiple} byl smazán!',
    FAILED_DELETE_ASSIGNMENT: 'Nepovedlo se odstranění úkolu {multiple}',
    DELETE_ASSIGNMENT: 'Smazat úkol {multiple}',
    DELETE_ASSIGNMENT_CONFIRMATION: 'Chcete smazat vybratý úkol {multiple}?',
    COLUMNS: 'Sloupce',
    FORMATTING: 'Formátování',
    PRESERVE_FORMATTING: 'Zachovat formátování',
    CUSTOM_FORMATTING: 'Vlastní formátování',
    GROUP_OUTLIERS: 'Seskupit odlehlé hodnoty',
    VERSIONS: 'Verze',
    NONE_VERSION: 'žádný',
    APPLY_TO_ALL_YEARS: 'Použít na všechny roky',
    SHEET_OPTIONS: 'Možnosti sheetu',
    DASHBOARD_OPTIONS: 'Možnosti přístrojové desky',
    LOCK_GRID: 'Zamknout mřížku',
    RESPONSIVE_LAYOUT: 'Responzivní rozložení',
    AUTO_REFRESH_DASHBOARD: 'Automatická aktualizace panelu',
    REFRESH_DASHBOARD: 'Aktualizovat panel',
    ONLY_WITH_DATA: 'Pouze s daty',
    OWD_INCLUDE_MEASURES: 'Zahrnout míry',
    SHOW_NO_RESULT_ROWS: 'Zobrazit řádky "No Result"',
    STACKED: 'Stackovaný',
    TIMELINE: 'Časová osa',
    RESET_COLUMN_ORDER: 'Obnovit pořadí sloupců',
    STANDARD_COLUMNS_NAME: 'Název',
    STANDARD_COLUMNS_DESCRIPTION: 'Popis',
    STANDARD_COLUMNS_NAME_PLUS_DESCRIPTION: 'Název + popis',
    DOWNLOADING_FILE: 'Stahování souboru',
    FILE_DOWNLOADED: 'Soubor stažený',
    FAIL_FILE_DOWNLOAD: 'Selhalo exportování z dané konfigurace',
    ADD_TO_DASHBOARD: 'Přidat na dashboard',
    COPY_TO_DASHBOARD: 'Kopírovat do dashboardu',
    SUBMIT_ENTRIES_CONFIRMATION: 'Opravdu chcete odeslat záznamy?',
    FURTHER_CHANGES_AND_LINK_LOCKED_AFTER_SUBMIT: 'Po odeslání nebudete moci provádět další změny a odkaz bude uzamčený.',
    LINK_NOT_FOUND: 'Odkaz nenalezen',
    LINK_EXPIRED: 'Tento odkaz vypršel',
    DEPLOYMENT: 'Nasazení',
    UNKNOWN: 'Neznámý',
    FILE_SIZE_10GB: 'Velikost souboru > 10 GB',
    FILE_SIZE_64MB: 'Velikost souboru > 64 MB',
    FILE_SIZE_1MB: 'Velikost souboru > 1 MB',
    FILE_SIZE_TOO_LARGE: 'Velikost souboru je příliš velká',
    LINK_URL_PLACEHOLDER: 'Vložte odkaz a stiskněte Enter',
    LINK_URL_INVALID: 'Odkaz musí začínat https://, http:// nebo #/',
    UPLOADED: 'Nahrané',
    ERROR_UPLOADING_FILE: 'Chyba při nahrávání souboru',
    FOLDER_NAME: 'Název složky',
    NEW_DIMENSION_TABLE: 'Nová dimenzní tabulka',
    NEW_VARIABLE: 'Nová proměnná',
    NEW_DASHBOARD: 'Nová přístrojová deska',
    NEW_SHEET: 'Nový sheet',
    UPLOAD_FILE: 'Nahrajte soubor',
    NEW_FOLDER: 'Nová složka',
    NEW_REMOTE_JOB: 'Nová aplikace',
    DOWNLOAD: 'Stáhnout',
    DELETE_MENU_ITEM_CONFIRM: 'Opravdu chcete smazat {menuItem}?',
    USER_REMOVED: 'Uživatel byl odstraněn!',
    FAILED_USER_REMOVE: 'Nepodařilo se odstranit uživatele',
    USER_DELETING: 'Mazání uživatele {fullName}',
    USER_DELETING_CONFIRM: 'Opravdu chcete smazat uživatele {fullName}?',
    CONFIRM_DELETE_OPERATION: 'Potvrďte smazání operace',
    DELETE_YEAR_CONFIRMATION: 'Opravdu chcete smazat rok {year}?',
    DELETE_VARIATION_CONFIRMATION: 'Opravdu chcete smazat variaci {name}?',
    YEARS: 'Roky',
    YEAR: 'Rok',
    ADD_YEAR: 'Přidat {year}',
    OPTIONS: 'Možnosti',
    NO_VERSION_SELECTED: 'Není vybrána žádná verze',
    INTERVAL_START_GREATER: 'Počátek intervalu větší než některé konce intervalu',
    INTERVAL_END_GREATER: 'Konec intervalu menší než některé začátky intervalu',
    INTERVAL_START_GREATED_END: 'Počátek intervalu větší než konec',
    NO_NAME_INPUT: 'Úkol musí mít název',
    EDIT_ASSIGNMENTS: 'Upravit úkoly',
    ASSIGNMENT_NAME: 'Název úkolu',
    VERSION: 'Verze',
    ADD_VERSION: 'Přidat verzi',
    ADD_NEW_VERSION: 'Přidat novou verzi',
    NEW_VERSION_NAME: 'Název nové verze',
    ERROR_ADDING_VERSION: 'Chyba při přidávání verze.',
    NAME_AND_COLOR: 'Jméno a barva',
    ADDED_BY: 'Přidal',
    CREATE_SERVICE_USER: 'Vytvořit uživatelského účtu',
    CREATE_USER: 'Vytvořit uživatele',
    USER_TYPE: 'Typ uživatele',
    STANDARD: 'STANDARD',
    SERVICE: 'SLUŽBA',
    CREATED_SERVICE_USER: 'Službeni korisnik stvoren',
    FAILED_CREATE_SERVICE_USER: 'Nepodařilo se vytvořit uživatele služby a klíč API',
    SERVICE_USER_NAME_REQUIRED: 'Je vyžadováno jméno uživatele služby',
    CREATED_USER: 'Uživatel vytvořen',
    FAILED_CREATE_USER: 'Nepodařilo se vytvořit uživatele',
    LAST_NAME_REQUIRED: 'Příjmení je vyžadováno',
    FIRST_NAME_REQUIRED: 'Křestní jméno je vyžadováno',
    EMAIL_REQUIRED: 'E-mail je povinný',
    PASSWORD_REQUIRED: 'Heslo je povinné',
    PASSWORD_INCORRECT: 'Nesprávné heslo',
    FIRST_NAME: 'Křestní jméno',
    LAST_NAME: 'Příjmení',
    EMAIL: 'E-mail',
    PASSWORD: 'Heslo',
    CONFIRM_PASSWORD: 'Potvrďte heslo',
    API_KEY: 'Klíč API',
    CREATED_SERVICE_USER_API_KEY: 'Byl vytvořen klíč API pro uživatele služby {serviceUserName}',
    API_KEY_COPIED_TO_CLIPBOARD: 'Klíč API byl zkopírován do schránky',
    MANAGE_API_KEYS: 'Spravovat klíče API',
    API_KEYS_FOR_USER: 'Klíče API – {name}',
    API_KEYS_SHOWN_ONCE: 'Klíče se zobrazí pouze jednou, při jejich vytvoření.',
    API_KEYS_ROTATE_HINT: 'Chcete-li klíč vyměnit, vytvořte nový, aktualizujte integraci a poté starý klíč smažte.',
    API_KEYS_EMPTY: 'Tento uživatel nemá žádné klíče API.',
    CREATE_API_KEY: 'Vytvořit klíč API',
    EDIT_API_KEY: 'Upravit klíč API',
    API_KEY_UPDATED: 'Klíč API byl aktualizován',
    CREATE_SERVICE_USER_API_KEY: 'Vytvořit klíč API',
    API_KEY_CREATED: 'Klíč API byl vytvořen',
    API_KEY_COPY_NOW: 'Zkopírujte si klíč nyní. Znovu se již nezobrazí.',
    API_KEY_UNTITLED: 'Klíč bez názvu',
    API_KEY_DESCRIPTION_PLACEHOLDER: 'např. Export SAP – produkce',
    API_KEY_CREATED_AT: 'Vytvořeno',
    API_KEY_CREATED_BY: 'Vytvořil',
    API_KEY_EXPIRES: 'Platnost do',
    API_KEY_EXPIRY: 'Platnost',
    API_KEY_EXPIRY_IN_PAST: 'Konec platnosti musí být v budoucnosti',
    API_KEY_NEVER_EXPIRES: 'Nikdy',
    API_KEY_EXPIRES_IN_DAYS: 'za {days} {{den|dní}}',
    API_KEY_EXPIRES_TODAY: 'Vyprší dnes',
    API_KEY_EXPIRED_ON: 'Vypršelo {date}',
    API_KEY_MANAGED_BY_OVERSEER: 'Spravováno Overseerem',
    API_KEY_MANAGED_BY_OVERSEER_HINT: 'Mění ho podpora Farseer. Zde jej nelze upravit ani smazat.',
    API_KEY_DELETE_QUESTION: 'Smazat klíč API „{name}“? Integrace, které jej používají, okamžitě přestanou fungovat.',
    API_KEY_DELETED: 'Klíč API byl smazán',
    CONNECT: 'Připojit se',
    DISCONNECT: 'Odpojit',
    MIXED_VERSIONS: 'Smíšené verze',
    MIXED: 'Smíšené',
    USE_RESTRICTIONS: 'Omezit zápis na verze a intervaly',
    ALLOW_ENTRY_ON_PROPERTY_COLUMNS: 'Povolit zápis do sloupců vlastností',
    PROPERTY_COLUMNS: 'Sloupce vlastností',
    USE_TIME_LIMIT: 'Použít časový limit',
    SELECT_VERSION: 'Vyberte verzi',
    EXPIRES_AFTER: 'Vyprší po',
    CHANGE: 'Změnit',
    SMART_FILTER_CHANGE: 'Změna',
    CHANGES_SUBMITTED: 'Změny byly odeslány. Čeká se recenze.',
    SUBMITTED: 'Odesláno',
    ASSIGNMENTS_AVAILABLE: 'dostupné úkoly',
    SUBMITTING_ASSIGNMENT: 'Odesílání úkolu',
    SUBMITED_ASSIGNMENT: 'Úkol byl odeslán',
    FAIL_SUBMIT_ASSIGNMENT: 'Nezdařilo se odeslat úkol',
    ASSIGNMENT_LABEL_CREATED: 'Název byl vytvořen a přidán k úkolu',
    SUBMIT_CHANGES: 'Odeslat změny?',
    SUBMIT_CHANGES_CONFIRMATION: 'Jste si jisti, že chcete odeslat změny? Nebudete moci provádět další úpravy, proces bude označen jako připraven k recenzi a vlastník této tabulky bude informován.',
    CANT_UNDONE_ACTION: 'Tato akce nemůže být vrácena zpět',
    APP_LANGUAGE: 'Jazyk aplikace',
    TARGET_VERSION_SAME_AS_SOURCE_VERSION_ERROR: 'Cílová verze nemůže být stejná jako zdrojová verze',
    TARGET_VERSION: 'Cílová verze',
    SELECT_TARGET_VERSION: 'Prosím vyberte cílovou verzi',
    SOURCE_VERSION: 'Zdrojová verze',
    SELECT_SOURCE_VERSION: 'Prosím vyberte zdrojovou verzi',
    ROW_TAGS: 'Řádkové značky',
    DELETE_THIS_ROW: 'Smazat tento řádek',
    SELECT_PARENT_TAG_FOR_MULTIPLE_ROWS_GENERATING: 'Vyberte nadřazenou značku pro generování více řádků',
    GLOBAL_SEARCH_PLACEHOLDER: 'Vyhledávejte sheety, řídicí panely, databázové tabulky a proměnné',
    NO_RESULTS_FOUND: 'Žádné výsledky',
    NEW_TILE: 'Nový panel',
    SLICER_STATE_SAVED: 'Stav sliceru uložen pro všechny!',
    INVALID_LINK: 'Neplatný odkaz',
    LINK_NOT_EXIST: 'Odkaz neexistuje',
    ACCESS_NOT_GRANTED: 'Přístup k hostiteli není udělen',
    CONTACT_ADMIN: 'Kontaktujte svého správce pro více informací.',
    LOGOUT: 'Odhlásit se',
    REGENERATING_LINKS: 'Obnova odkazů...',
    REGENERATED: 'Obnoveno!',
    FAILED_REGENERATING_LINKS: 'Nepodařilo se obnovit odkazy pro vybrané veřejné úkoly.',
    REGENERATING_LINKS_SELECTED_ASSIGNMENTS: 'Obnovit odkazy pro vybrané úkoly?',
    REGENERATING_LINKS_SELECTED_ASSIGNMENTS_CONFIRMATION: 'Jste si jisti, že chcete obnovit odkazy pro vybrané úkoly? Staré odkazy budou neplatné. Tato akce nemůže být vrácena zpět.',
    REGENERATE: 'Obnovit',
    REGENERATE_LINK: 'Obnovit odkaz',
    SHEET_NOT_FOUND: 'Tabulka nenalezena',
    CLUSTER_NOT_FOUND: 'Cluster nenalezen',
    PARENT_CLUSTER_NOT_FOUND: 'Nadřazený cluster nenalezen',
    TAG_NOT_FOUND: 'Značka nenalezena',
    SHEET_ID_NOT_FOUND: 'Id tabulka nenalezen',
    FAIL_CREATE_ROW: 'Vytvoření řádku se nezdařilo',
    FAIL_CREATE_CLUSTER: 'Vytvoření clusteru se nezdařilo',
    ROW_CREATED: 'Řádek vytvořen',
    COLUMN_CREATED: 'Sloupec vytvořen',
    DIMENSION_CREATED: 'Dimenze vytvořena',
    NOT_IMPLEMENTED_YET: 'Zatím není implementováno',
    VARIABLE_SHOULD_CONTAIN_ONLY_VARIABLES: 'Pole proměnných by mělo obsahovat pouze proměnné',
    UNKNOWN_ZONE_SINGLE_VALUE: 'Neznámá zóna v jedné hodnotě',
    FILTER_FIELD_SHOULD_CONTAIN_DIMENSION_TAGS: 'Pole filtru by mělo obsahovat dimenzi značky',
    UNKNOWN_ZONE_DATA_EDITOR: 'Neznámá zóna v editoru dat',
    VARIABLE_FILED_SHOULD_CONTAIN_ACCOUNT_TAG: 'Pole proměnných by mělo obsahovat účetní značky',
    CUSTOM_COLUMN_NOT_FOUND: 'Přizpůsobený sloupec nenalezen',
    CANT_ADD_TO_COLUMN: 'Nemůžu přidat {tagType} do typu sloupce {columnType}',
    TAG_ALREADY_ADDED: 'Tato značka již byla přidána',
    MODEL_IMPORT_IN_PROGRESS: 'Import modelu probíhá...',
    MODEL_IMPORT_SUCCESS: 'Model byl úspěšně importován.',
    CODE_EDITOR_ALLOW_CHANGES: 'Povolit editoru kódu provést změny v modelu:',
    ALLOW_ALL: 'Povolit vše',
    DELETE_MEMBER_ROWS: 'Smazat řádky',
    DELETE_TABLES: 'Smazat tabulky',
    DELETE_VARIABLES: 'Smazat proměnné',
    DELETE_COLUMNS: 'Smazat sloupce',
    DELETE_EVERYTHING: 'Smazat vše při aplikování změn',
    DRY_RUN: 'Suchý běh',
    MODEL_CODE_EDITOR: 'Editor kódu modelu',
    MODEL_IMPORT_EXPORT: 'Import/Export modelu',
    MODEL_IMPORT: 'Import modelu',
    MODEL_EXPORT: 'Export modelu',
    MODEL_USE_IN_EXPORT: 'Použít v exportu',
    MODEL_OBJECT_TYPE: {
        DTAB: 'Tabulky dimenzí',
        DMEM: 'Členové dimenzí',
        VAR: 'Proměnné',
        CELL: 'Buňky',
    },
    LOADING: 'Načítání...',
    CHAT_STATUS_ANALYZING_CONTEXT: 'Analyzování vaší otázky',
    CHAT_STATS_ACTIONS: '{count} {{akce|akcí}}',
    CHAT_STATS_CONTEXT: '{tokens} kontext',
    CHAT_STATS_DURATION_TOOLTIP: 'Jak dlouho trvalo vygenerování této odpovědi',
    CHAT_STATS_ACTIONS_TOOLTIP: 'Kolik akcí agent provedl (načítání dovedností, spouštění kódu)',
    CHAT_STATS_CONTEXT_TOOLTIP: 'Aktuální velikost kontextu konverzace. Starší části se shrnou, jakmile bude příliš velký.',
    CHAT_DEFAULT_TITLE: 'Chat',
    CHAT_ENTER_FULLSCREEN: 'Zobrazit na celou obrazovku',
    CHAT_EXIT_FULLSCREEN: 'Opustit celou obrazovku',
    CHAT_RENAME: 'Přejmenovat chat',
    CHAT_DELETE: 'Smazat chat',
    CHAT_CREATE_NEW: 'Vytvořit nový chat',
    CHAT_MESSAGE_PLACEHOLDER: 'Zpráva pro FarseerAI...',
    CHAT_SEND: 'Odeslat',
    CHAT_RENAME_TITLE: 'Přejmenovat chat',
    CHAT_HELP_QUESTION: 'S čím vám mohu dnes pomoci',
    CHAT_SUGGESTED: 'Navrhované',
    CHAT_GENERATING_SUGGESTIONS: 'Přizpůsobování návrhů vašemu modelu…',
    CHAT_SUGGESTED_SUMMARY: 'Podej mi stručné shrnutí modelu',
    CHAT_SUGGESTED_VARIANCE: 'Jaká je letos největší odchylka mezi skutečností a plánem a proč?',
    CHAT_SUGGESTED_DRIVERS: 'Rozveďte, co ovlivňuje moje výsledky v tomto čtvrtletí',
    CHAT_SUGGESTED_DASHBOARD: 'Vytvořte pro tento model dashboard s přehledem pro vedení',
    CHAT_SUGGESTED_PNL_DASHBOARD: 'Vytvořte P&L dashboard porovnávající skutečnost s plánem',
    CHAT_SUGGESTED_APPS: 'Co odtud mohu spustit? Ukažte mi moje dostupné aplikace',
    CHAT_SUGGESTED_RANKING: 'Ukažte mi letos moje nejlepší a nejhorší výkony',
    CHAT_CREATED: 'Chat vytvořen!',
    CHAT_CREATED_NEW: 'Nový chat vytvořen!',
    CHAT_RENAMED: 'Chat přejmenován!',
    CHAT_DELETED: 'Chat smazán!',
    CHAT_FAILED_CREATE: 'Nepodařilo se vytvořit nový chat.',
    CHAT_FAILED_LOAD: 'Nepodařilo se načíst chaty.',
    CHAT_FAILED_RENAME: 'Nepodařilo se přejmenovat chat.',
    CHAT_FAILED_DELETE: 'Nepodařilo se smazat chat.',
    CHAT_FAILED_CANCEL: 'Nepodařilo se zrušit požadavek.',
    CHAT_FEEDBACK_FAILED: 'Nepodařilo se uložit zpětnou vazbu.',
    CHAT_FEEDBACK_THUMBS_UP: 'Dobrá odpověď',
    CHAT_FEEDBACK_THUMBS_DOWN: 'Špatná odpověď',
    CHAT_FEEDBACK_COMMENT_TITLE: 'Řekněte nám, co se pokazilo',
    CHAT_FEEDBACK_COMMENT_PLACEHOLDER: 'Co bylo užitečné nebo co se pokazilo? (volitelné)',
    CHAT_FEEDBACK_COMMENT_SAVE: 'Uložit',
    CHAT_FEEDBACK_CLEAR: 'Vymazat zpětnou vazbu',
    CHAT_AGENT_TYPE_ANALYST: 'Analytik',
    ADVANCED_SETTINGS: 'Pokročilé nastavení',
    INVALID_JSON_ERROR: 'Neplatný JSON: {message}',
    MAINTENANCE_MODE_CURRENTLY_ENABLED: 'Režim údržby je momentálně zapnutý',
    MAINTENANCE_MODE_ENABLED: 'Režim údržby je aktuálně povolen',
    CONTACT_ADMIN_FOR_INFO: 'Počkejte prosím nebo kontaktujte svého správce pro více informací.',
    RETRY: 'Zkusit znovu',
    OTHER_WORKSPACES_AVAILABLE: 'Přepněte do pracovního prostoru, ke kterému máte přístup:',
    COPY_LINK: 'Kopírovat odkaz',
    COPY_DATA_FROM: 'Kopírovat data z',
    ROWS_CUT: 'Řádky vyříznuty',
    ROWS_COPIED: 'Řádky zkopírované',
    ROWS_MOVED: 'Pohybované řádky',
    ROWS_PASTED: 'Vložené řádky',
    CELLS_CUT: 'Buňky vyříznuty',
    CELLS_COPIED: 'Buňky zkopírované',
    CELLS_COPIED_FROM: 'Buňky zkopírované z „{label}“',
    FAILED_CELLS_COPIED: 'Kopírovaní bunek se nezdařilo {message}',
    CANNOT_CELLS_PASTED: 'Nemůžete vložit buňky sem',
    NAMED_COPY: '{name} (kopie)',
    TAG: 'Značka',
    ACTION: 'Akce',
    MANAGE_CONNECTIONS_FOR: 'Správa připojení pro',
    RENAME: 'Přejmenovat',
    RENAME_FILE_EXTENSION_REQUIRED: 'Názvy souborů musí mít příponu, například .csv nebo .xlsx.',
    RENAME_FILE_EXTENSION_CHANGE_TITLE: 'Změnit příponu souboru?',
    RENAME_FILE_EXTENSION_CHANGE_QUESTION: 'Tím se změní přípona z „.{oldExt}“ na „.{newExt}“, což může změnit způsob otevření souboru. Pokračovat?',
    REMOVE_COLUMN: 'Odebrat sloupec',
    REMOVE_CONNECTION: 'Odebrat připojení',
    TABLE_CONNECTION: 'Připojení tabulky',
    TEXT: 'Text',
    TEXT_COLUMN: 'Textový sloupec',
    NUMBER: 'Číslo',
    NUMBER_COLUMN: 'Číselný sloupec',
    NEW_NUMBER_COLUMN: 'Nový číselný sloupec',
    FILE: 'Soubor',
    FILE_COLUMN: 'Souborový sloupec',
    DATE_COLUMN: 'Datový sloupec',
    EDIT_TAG_TYPE: 'Upravit {tagTypeName}',
    DELETE_TAG_TYPE: 'Smazat {tagTypeName}',
    DELETE_TAG_TYPE_DATA: 'Smazat podatke {tagTypeName}',
    CONNECTIONS: 'Spojení',
    EDIT_CONNECTIONS: 'Upravit spojení',
    CLEAR_FIELD: 'Vymazat pole',
    ERROR_CLEAR_FIELD: 'Chyba při mazání pole',
    REPLACE_FILE: 'Nahradit soubor',
    DOWNLOAD_FILE: 'Stáhnout soubor',
    DOWNLOAD_ORIGINAL_FILE: 'Stáhnout původní soubor',
    FILE_DOES_NOT_EXIST: 'Soubor neexistuje',
    DELETE_FILE: 'Smazat soubor',
    ERROR_DELETE_FILE: 'Chyba při mazání souboru',
    LOCKS: 'Zámky',
    YEARS_VERSIONS_MONTHS: 'Roky / Verze / Měsíce',
    CUSTOM_LOCK_RULES: 'Vlastní pravidla uzamčení',
    STANDARD_LOCK_RULES: 'Standardní pravidla uzamčení',
    LOCK_RULES_WILL_BE_CONVERTED_TO_STANDARD: '{{1 pravidlo uzamčení|?? pravidla uzamčení}} budou použita na tabulku Roky / Verze / Měsíce',
    LOCK_WILL_BE_CONVERTED_TO_STANDARD: 'Toto pravidlo uzamčení bude použito na výše uvedenou tabulku Roky / Verze / Měsíce.',
    NO_CUSTOM_LOCKS_DEFINED: 'Nejsou definována žádná vlastní pravidla uzamčení',
    LOCK_REFERENCES_DELETED_ENTITIES: 'Tento zámek odkazuje na smazané entity',
    TABLE_SETTINGS: 'Nastavení tabulky',
    NEW_MEMBER: 'Nový člen',
    SORT_TABLE: 'Seřadit tabulku',
    LOCK_TABLE: 'Uzamknout tabulku',
    UNLOCK_TABLE: 'Odemknout tabulku',
    TABLE_LOCKED_TOOLTIP: 'Tato tabulka je uzamčena',
    UNLOCK_SYSTEM_TABLE_TITLE: 'Odemknout systémovou tabulku',
    UNLOCK_SYSTEM_TABLE_WARNING: 'Toto je systémová tabulka. Její odemknutí může ovlivnit integritu modelu. Opravdu ji chcete odemknout?',
    ERROR_LOCKING_TABLE: 'Chyba při uzamykání tabulky.',
    ERROR_UNLOCKING_TABLE: 'Chyba při odemykání tabulky.',
    NAME_ASCENDING: 'Název vzestupně',
    NAME_DESCENDING: 'Název sestupně',
    ADD_SORT_RULE: 'Přidat pravidlo řazení',
    REMOVE_ALL_SORT_RULES: 'Odebrat všechna pravidla řazení',
    '1_SORT': '1 řazení',
    N_SORTS: '{count} řazení',
    DESCRIPTION_ASCENDING: 'Popis vzestupně',
    DESCRIPTION_DESCENDING: 'Popis sestupně',
    SORTING_DIMENSIONS: 'Řazení dimenzí...',
    DIMENSIONS_SORTED: 'Dimenze seřazeny!',
    ERROR_SORTING_DIMENSIONS: 'Chyba při řazení dimenzí.',
    EDITING_TIMELINE_SLICER: 'Úprava časového řezáku {title}',
    CREATE_NEW_TIMELINE_SLICER: 'Vytvořit nový časový řezák',
    INTERVAL_START: 'Počátek intervalu',
    INTERVAL_END: 'Konec intervalu',
    FORMAT: 'Formát',
    OPERATION: 'Operace',
    MY_PROFILE_INFORMATION: 'Informace o mém profilu',
    PROFILE_SETTINGS: 'Nastavení profilu',
    ADD_PHOTO: 'Přidat fotografii',
    CHANGE_PHOTO: 'Změnit fotografii',
    UPDATE_PHOTO: 'Aktualizovat fotografii',
    REMOVE_PHOTO: 'Odstranit fotografii',
    DECIMAL_SEPARATOR: 'Desetinná znaménka',
    DATE_FORMAT: 'Formát data',
    DATE_SEPARATOR: 'Oddělovač datumu',
    ACCESSIBLE_CHART_PATTERNS: 'Vzory přístupnosti pro grafy',
    SET_AS_DEFAULT_PALETTE: 'Nastavit jako výchozí paletu',
    SAVE_CURRENT_COLORS_AS_PALETTE: 'Uložit aktuální barvy jako paletu',
    DELETE_PALETTE: 'Smazat paletu',
    FILL_STYLE: 'Styl výplně',
    SOLID: 'Plné',
    HATCHED: 'Šrafované',
    VARIABLE: 'Proměnná',
    DIMENSION: 'Rozměr',
    CREATE_OR_GENERATE_NEW_ROWS: 'Vytvořit nebo generovat nové řádky',
    CREATE_ROW_AS: 'Vytvořit {row} jako',
    GENERATE_ROWS_FROM: 'Generovat řádky z',
    CREATE_NEW_VARIABLE: 'Vytvořit novou proměnnou',
    ENTER_FORMULA_FOR: 'Zadejte formuli pro {variableName}',
    SELECT_A_VARIABLE_FORMULA: 'Vyberte proměnnou pro zobrazení nebo úpravu formule',
    DATABASE_AND_PROPERTIES: 'Databázové objekty a vlastnosti',
    FOLDER_EMPTY: 'Složka je prázdná',
    DASHBOARD_EMPTY: 'Dashboard je prázdný',
    DASHBOARD_HINT: 'Začněte s vaší řídicí tabulí vytvořením dlaždic.',
    YEARS_SETTINGS: 'Nastavení let',
    FINANCIAL_YEAR_STARTING_MONTH: 'Měsíc začátku finančního roku',
    UPDATING_FINANCIAL_YEAR_STARTING_MONTH: 'Aktualizace počátečního měsíce finančního roku',
    FINANCIAL_YEAR_STARTING_MONTH_UPDATED: 'Počáteční měsíc finančního roku aktualizován',
    SOMETHING_WENT_WRONG: 'Něco se pokazilo.',
    SEARCH_FOR_USERS: 'Hledat uživatele...',
    SEARCH_FOR_GROUPS: 'Hledat skupiny...',
    SEARCH_BY_GROUP_OR_USER: 'Hledat podle skupiny nebo uživatele',
    USERS: 'Uživatelé',
    GROUPS: 'Skupiny',
    USER_OR_GROUP: 'Uživatel/Skupina',
    PERMISSIONS: 'Oprávnění',
    END_DATE_MUST_BE_GREATER_THAN_START_DATE: 'Konec datuma musí být větší než začátek datuma',
    HISTORY_DATA_CANNOT_OVERLAP_WITH_FORECAST_DATA: 'Historická data nesmí překrývat data předpovědi',
    PLEASE_CHOOSE_AN_ACCOUNT_TAG: 'Prosím vyberte štítek účtu',
    ERROR_STARTING_FORECAST: 'Chyba při spuštění předpovědi',
    CUSTOM_FORECAST: 'Vlastní předpověď',
    HISTORICAL_DATA_FROM: 'Historická data od',
    HISTORICAL_DATA_TO: 'Historická data do',
    SOURCE_VARIABLE_AND_DIMENSIONS: 'Zdrojová proměnná a rozměry',
    ERROR: 'Chyba {message}',
    FORECAST: 'Předpověď',
    VIEW_FORECASTS_FOR_PERIOD: 'Zobrazit předpovědi pro období',
    NO_JOBS_FOR_SELECTED_PERIOD: 'Žádné práce pro vybrané období',
    ACTIVE_JOBS: 'Aktivní práce',
    FINISHED_JOBS: 'Dokončené práce',
    COMPLETED_ON: 'Dokončeno v {time}',
    FORECAST_PROGRESS: 'Pokrok předpovědi',
    ERROR_LOADING_FORECAST_JOBS: 'Chyba při načítání úloh předpovědi.',
    PAGE: 'Stránka',
    EDIT_ENTRY: 'Upravit záznam',
    NEW_ENTRY_BY_DATE: 'Nový záznam podle data',
    TAGS: 'Štítky',
    ADD_TAG: 'Přidat štítek',
    START_YEAR: 'Startovní rok',
    START_MONTH: 'Startovní měsíc',
    END_YEAR: 'Koncový rok',
    END_MONTH: 'Koncový měsíc',
    MUST_SELECT_ROW: 'Musíte vybrat řádek',
    TITLE: 'Název',
    SUBTITLE: 'Podtitulek',
    FOOTNOTES: 'Poznámky pod čarou',
    ROW: 'Řádek',
    SELECT_ROW: 'Vyberte řádek',
    COLUMN: 'Sloupec',
    ROW_NAME_DISPLAY: 'Zobrazení názvu řádku',
    BOTH: 'Obě',
    SHARED_COLUMN_CONFIG_PRESET: 'Sdílená konfigurace sloupce',
    SHOW_ZERO_SUM_ROWS: 'Zobrazit řádky s nulovým součtem',
    USE_DATA_FROM_TIMELINE_SLICER: 'Použijte data z časového sliceru',
    USE_DATA_FROM_DIMENSION_SLICER: 'Použijte data z řezáče dimenze',
    DELETE_TARGET_AND_RELATED_DATA: 'a související data?',
    DELETE_TARGET_CHILDREN: 'Smazat děti',
    DELETE_TARGET_DATA: 'Smazat data pro',
    CONFIRM_DELETE_ROW: 'Smazat řádek?',
    CONFIRM_DELETE_ROWS: 'Smazat {count} řádků?',
    CONFIRM_DELETE_ROWS_GENERATED: 'Smazat generované řádky?',
    CONFIRM_DELETE_ROWS_MIXED: 'Smazat řádky a generované řádky?',
    EXPLAIN_DELETE_ROW: 'Toto smaže <>{row}<>',
    EXPLAIN_DELETE_ROWS_GENERATED: 'Toto smaže vygenerované řádky z <>{table}<> z tohoto sheetu.',
    EXPLAIN_DELETE_ROWS_MIXED: 'Toto smaže <>{count} řádek(ů)<> a vygenerované řádky z <>{table}<> z tohoto sheetu.',
    EXPLAIN_DELETE_ROWS_SUBROWS: 'Toto také smaže všechny podřádky. Tuto akci nelze vrátit zpět.',
    FAILED_DELETE_ROW: 'Nepodařilo se smazat řádek',
    DELETE_ROW_AND_ITS_CHILDREN_CONFIRMATION: 'a všechny jeho podřádky a položky?',
    NO_ACCESS_TO_DELETE_ROWS: 'Nemáte přístup k uvedeným řádkům, takže je nemůžete smazat.',
    CREATE_GROUP: 'Vytvořit skupinu',
    EDIT_PERMISSIONS: 'Upravit oprávnění',
    USERS_AND_GROUPS_MANAGEMENT: 'Správa uživatelů a skupin',
    SUM: 'Součet',
    COUNT: 'Počet',
    AVERAGE: 'Průměr',
    CLOSING_STATE: 'Uzavírací stav',
    BEGINNING_STATE: 'Počáteční stav',
    FORMULA: 'Vzorec',
    MAX: 'Maximum',
    MIN: 'Minimum',
    YES: 'Ano',
    NO: 'Ne',
    YESTERDAY: 'Včera',
    CONFIRM_VARIABLE_REMOVE: 'Potvrďte odebrání proměnné',
    CONFIRM_VARIABLES_REMOVE: 'Potvrďte odebrání proměnných',
    REMOVE_VARIABLE_CONFIRMATION: 'Jste si jisti, že chcete odstranit proměnnou',
    REMOVE_VARIABLES_CONFIRMATION: 'Jste si jisti, že chcete odstranit proměnné:',
    REMOVE_VARIABLES_COUNT_CONFIRMATION: 'Jste si jisti, že chcete odstranit {tagNumber} proměnné?',
    EDIT_VARIABLE: 'Upravit proměnnou',
    SHARE_VARIABLE: 'Sdílet proměnnou',
    DELETE_VARIABLE_DATA: 'Smazat data proměnné',
    DELETE_VARIABLE: 'Smazat proměnnou',
    EXPAND_MORE: 'Rozbalit více',
    COLLAPSE_ALL: 'Sbalit vše',
    SCROLL_TO_BOTTOM: 'Posunout dolů',
    VARIABLE_METRICS: 'Metriky proměnné',
    VARIABLE_TABLE_COLUMNS: {
        Name: 'Název',
        Description: 'Popis',
        Formula: 'Vzorec',
        Dimensions: 'Rozměry',
        'Read-only': 'Pouze pro čtení',
        'Roll-up type': 'Typ sloučení',
    },
    LOADING_DATA: 'Načítání dat…',
    SUCCESSFULLY_LOADED_DATA: 'Data načtena',
    LOADING_DATA_FAILED: 'Data se nepodařilo načíst',
    LOADING_DATA_FAILED_SUBTITLE: 'Zkuste obnovit stránku',
    WAITING: 'Čekání...',
    VIEW_LOGS: 'Zobrazit záznamy',
    LOADING_DATA_LOG: 'Protokol načítání dat',
    CALCULATION_STARTED: 'Výpočet začal',
    CALCULATION_FINISHED: 'Výpočet dokončen',
    DATABASE_LOADED: 'Databáze načtena. Počet načtených buněk: {numberOfCells}',
    VARIABLE_CALCULATION_STARTED: 'Výpočet proměnné {variableName} začal. Počet vstupních buněk: {numberOfCells}',
    VARIABLE_CALCULATION_ENDED: 'Výpočet proměnné {variableName} dokončen. Počet buněk: {numberOfCells}, výstupní/vstupní faktor: {outInFactor}.',
    NEW_ROW: 'Nový řádek',
    NEW_TEMPLATE_OR_ROW: '',
    ADD_TEMPLATE_TO_TOOLBAR: 'Přidat do panelu nástrojů',
    REMOVE_TEMPLATE_FROM_TOOLBAR: 'Odebrat z panelu nástrojů',
    IN_TOOLBAR: 'V panelu nástrojů',
    TEMPLATE_ADDED_TO_TOOLBAR: 'Šablona přidána do panelu nástrojů',
    TEMPLATES: 'Šablony',
    SELECT_A_ROW: 'Vyberte řádek',
    FILE_CANT_BE_PREVIEWED: 'Soubor nelze zobrazit',
    THIS_TYPE_OF: 'Tento typ',
    INPUT_SETUP: 'Nastavení vstupu',
    ONDEMAND_CALCULATION: 'Výpočet na vyžádání',
    REFRESH_DATA: 'Obnovit data',
    DISABLE_MAINTENANCE_MODE: 'Zakázat režim údržby',
    ENABLE_MAINTENANCE_MODE: 'Povolit režim údržby',
    SAVED: 'Uloženo',
    FORMULA_ERROR: 'Chyba ve vzorci',
    UNEXPECTED: 'Neočekáváno',
    INVALID_SYNTAX: 'Neplatná syntaxe pro',
    MISSING_TOKEN_AFTER: 'Chybějící token po',
    UNNECESSARY: 'Zbytečný',
    ERROR_MESSAGE_OCCURRED: 'Došlo k chybě',
    INCOMPLETE_sheet_ITEM_DATA: 'Neúplné údaje o položkách',
    FAIL_SAVE_sheet_ITEMS: 'Selhalo uložení položek',
    HEADER_COLUMNS: {
        Description: 'Popis',
        Date: 'Datum',
        Version: 'Verze',
        'Variable and Dimensions': 'Proměnná a dimenze',
        Value: 'Hodnota',
        'Value type': 'Typ hodnoty',
        Action: 'Akce',
    },
    DESCRIPTION_UPDATE_DATE_TAGS_FAILED: 'Aktualizace popisů pro měsíc a rok se nezdařila.',
    COMPARISON: 'Srovnání',
    DISALLOW: 'Zakázat',
    USE_DEFAULT: 'Použít výchozí',
    SKIP_ROW: 'Přeskočit řádek',
    MISSING_MEMBERS_IMPORT_NOT_ALLOWED: 'Nepovolí import, pokud chybí členové.',
    MISSING_MEMBERS_SKIP_ROWS: 'Přeskočí řádky s chybějícími členy.',
    MISSING_MEMBERS_DEFAULT: 'Importuje údaje z chybějících členů do výchozího člena tabulky.',
    CONFIGURE_JOB_OPTIONS: 'Nakonfigurovat možnosti úlohy',
    HANDLE_MISSING_DIMENSION_MEMBERS: 'Manipulace s chybějícími členy rozměru',
    IMPORT_ZEROS: 'Importovat nuly',
    OVERWRITE_CELLS: 'Přepsat buňky',
    IGNORE_FINANCIAL_YEAR_OFFSET: 'Ignorovat posunutí finančního roku',
    SKIP_EMPTY_ROWS: 'Přeskočit prázdné řádky',
    SKIP_REPEATING_HEADER_ROWS: 'Přeskočit opakující se řádky záhlaví',
    SKIP_LOW_SIGNAL_ROWS_HEURISTIC: 'Přeskočit řádky s nízkou informační hodnotou (heuristika)',
    ROWS_WILL_BE_SKIPPED_ON_IMPORT: 'Při importu bude přeskočeno {count} řádků.',
    NO_ROWS_WILL_BE_SKIPPED_ON_IMPORT: 'Při importu nebudou přeskočeny žádné řádky.',
    INCLUDE_IN_IMPORT: 'Zahrnout do importu',
    EXCLUDE_FROM_IMPORT: 'Vyloučit z importu',
    MISSING_MEMBERS_REPLACE_ALL: 'Nahradit všechny předchozí členy rozměru',
    MISSING_MEMBERS_REPLACE_ALL_CONFIRMATION: 'Jste si jisti, že chcete nahradit všechny předchozí členy rozměru?',
    APPLY_MEMBERS_AND_VARIABLES_TO_VALUE_COLUMNS: 'Použít členy a proměnné na hodnotové sloupce',
    WRONG_RESULT_TYPE_FOR_COLUMN: 'Získán nesprávný typ výsledku pro sloupec {columnKey}',
    TRIED_TO_ADD_NON_UNIQUE_TAGS: 'Pokusil přidat nejedinečné štítky',
    TRIED_TO_CREATE_TAG_WITH_EMPTY_NAME: 'Pokusil vytvořit štítek s prázdným názvem',
    NO_PARENT_TAG_SELECTED: 'Není vybrán rodičovský štítek',
    COLUMN_MANAGER: 'Sloupce',
    NO_COLUMNS: 'Žádné sloupce',
    NEW_COLUMN_TIP: 'Můžete začít přidáním nového prvků sloupce. Pak použijte postranní lištu pro výběr a vytvoření vlastních sloupců.',
    NEW_COLUMN: 'Nový sloupec',
    COLUMN_TO_NUMBER_TYPE: 'Změna na číslo',
    COLUMN_TO_COMPARISON_TYPE: 'Změna na porovnání',
    COMPARISON_OPERATION: 'Operace',
    DROP_ELEMENTS: 'Sestavit prvky...',
    READONLY: 'Pouze pro čtení',
    CUSTOM_TITLE: 'Vlastní titul',
    SELECT_ROW_TO_DROP_ELEMENTS: 'Vyberte řádek pro odstranění prvků',
    CANT_MOVE_ROW_INSIDE_SELF: 'Nelze přesunout řádek do sebe',
    CLEAR_ALL: 'Vymazat všechno',
    MIGRATE_TO_SHEET: 'Migrace do tabulky',
    CHOOSE_TIME_PERIOD: 'Prosím vyberte časové období',
    NO_VARIABLE: 'Žádná proměnná',
    NO_ROWS_SELECTED: 'Žádné vybrané řádky',
    STARTING_YEAR_NOT_ACTIVE: 'Počáteční rok není aktivní',
    SHEET: 'Tabulka',
    ASSIGNEE: 'Přiřazená osoba',
    APPROVER: 'Schvalovatel',
    SHARED_TO: 'Sdíleno s',
    PUBLIC: 'Veřejný',
    PUBLIC_LINK: 'Veřejný odkaz',
    VERSIONS_AND_INTERVAL: 'Verze a intervaly',
    INTERVAL: 'Interval',
    EXPIRES_IN: 'Vyprší za',
    STATUS: 'Stav',
    STATUS_EXPIRES_IN: 'Stav (vyprší za)',
    PUBLIC_ASSIGNMENT_LINK_COPIED_TO_CLIPBOARD: 'Odkaz veřejného úkolu zkopírován do schránky',
    EXPORTING: 'Exportování...',
    APPROVE: 'Schválit',
    DISAPPROVE: 'Neschválit',
    EXPORT: 'Exportovat',
    EXPIRE: 'Vypršet',
    REFRESH: 'Obnovit',
    NO_ASSIGNMENTS_AVAILABLE: 'Žádné dostupné úkoly',
    MARK_IN_REVIEW: 'Označit jako v revizi',
    MARK_AS_UNRESOLVED: 'Označit jako nevyřešené',
    MARK_AS_RESOLVED: 'Označit jako vyřešené',
    GO_TO_ROW: 'Přejít na řádek',
    DELETE_THREAD: 'Smazat vlákno',
    REPLAY_OR_TAG_IN_COMMENT: 'Odpovědět nebo označit jiné pomocí @...',
    COMMENT_OF: 'Komentář {arrowsCurrent} z {arrowsAll}',
    COMMENT: 'Komentář',
    COMMENTS: 'Komentáře',
    LOADING_IMPORT_JOBS: 'Načítání importních úkolů',
    IMPORT_ROWS_TRUNCATED_WARNING: 'Datová sada je příliš velká pro úplné zobrazení. Je zobrazeno pouze prvních 200 000 řádků. Všechny řádky budou importovány při potvrzení.',
    SELECTED_JOB_DOESNT_EXIST: 'Vybraný úkol neexistuje',
    GO_BACK_TO_IMPORT: 'Vrátit se k importu',
    BACK_TO_IMPORT: 'Zpět k importu',
    AT_LEAST_ONE_CHART_LINE: 'Musíte přidat alespoň jednu čáru grafu.',
    AT_LEAST_ONE_X_AXIS_TAG: 'Musíte přidat alespoň jednu značku osy x',
    VISUALIZATION_TYPE: 'Typ vizualizace',
    VISUALISATION_OPTIONS: 'Možnosti vizualizace',
    EDIT_CHART: 'Úprava grafu "{title}"',
    BAR_CHART: 'Sloupcový graf',
    BAR: 'Sloupec',
    STACKED_BAR_CHART: 'Skládaný sloupcový graf',
    STACKED_BAR: 'Skládaný sloupec',
    WATERFALL_CHART: 'Vodopádový graf',
    WATERFALL: 'Vodopád',
    PIN_CHART: 'Špendlíkový graf',
    PIN: 'Špendlík',
    AREA_CHART: 'Plošný graf',
    AREA: 'Plocha',
    STACKED_AREA_CHART: 'Skládaný plošný graf',
    STACKED_AREA: 'Skládaná plocha',
    LINE_CHART: 'Čárový graf',
    LINE: 'Čára',
    COMBO_CHART: 'Kombinovaný graf',
    PIE_CHART: 'Koláčový graf',
    TRAFFIC_LIGHT: 'Semafor',
    INDICATOR: 'Ukazatel',
    SINGLE_VALUE: 'Jednotlivá hodnota',
    CREATE_CHART: 'Vytvořit nový graf',
    ORIENTATION_LAYOUT: 'Orientace a rozložení',
    HORIZONTAL: 'Horizontální',
    VERTICAL: 'Vertikální',
    SINGLE: 'Jednotlivé',
    GRID: 'Mřížka',
    THIN: 'Tenké',
    THICK: 'Tlusté',
    DOUBLE: 'Dvojité',
    DOT: 'Tečka',
    CIRCLE: 'Kruh',
    SQUARE: 'Čtverec',
    CATEGORY_AXIS: 'Osa kategorií',
    DOMAIN_AXIS: 'Doménová osa',
    SHOW_TOTALS: 'Zobrazit součty',
    SHOW_AXIS: 'Zobrazit osu',
    SHOW_VALUE_AXIS: 'Zobrazit osu hodnot',
    SHOW_CATEGORY_AXIS_LABELS: 'Zobrazit štítky osy kategorií',
    COMPACT_AXIS_LABELS: 'Kompaktní popisky osy',
    CATEGORY_LABEL_ANGLE: 'Úhel popisků kategorií',
    LABEL_FORMAT: 'Formát štítku',
    SHOW_LEGEND: 'Zobrazit legendu',
    SHOW_INTEGRATED_LEGEND: 'Zobrazit integrovanou legendu',
    VALUE_LABELS: 'Popisky hodnot',
    ROW_VALUE_LABELS: 'Popisky hodnot řádků',
    SHOW_VALUE_LABELS: 'Zobrazit hodnotové štítky',
    POSITION: 'Pozice',
    SMART_FILTERING: 'Inteligentní filtrování',
    TRANSPOSE_DATA: 'Použít sloupce jako série',
    NORMALIZE_TO_PERCENT: 'Normalizovat na 100 %',
    SHOW_EMPTY_ROWS: 'Zobrazit prázdné řádky',
    SHOW_EMPTY_COLUMNS: 'Zobrazit prázdné sloupce',
    GROUP_BY_PARENT_ROW: 'Seskupit podle nadřazeného řádku',
    ACCUMULATE_DATA: 'Vypočítat průběžný součet',
    COLOR_BY_VALUE: 'Barevně podle hodnoty',
    COLOR_BY_TREND: 'Barevně podle trendu',
    COLOR_TOTALS_BY_VALUE: 'Obarvit součty podle hodnoty',
    THRESHOLD_VALUE: 'Prahová hodnota',
    USE_SHARED_SCALE: 'Použít sdílené měřítko',
    STATIC: 'Statický',
    BY_VALUE: 'Podle hodnoty',
    BY_TREND: 'Podle trendu',
    BAR_SPACING: 'Mezera sloupců',
    GAP: 'Mezera',
    WIDTH: 'Šířka',
    USE_DATA_FROM_DIMENSION_SLICERS: 'Použít data z řezačů dimenzí',
    X_AXIS_DIMENSION_BUILDER: 'Tvůrce dimenzí osy X',
    ADD_REMOVE_X_AXIS_COLUMN: 'Přidat/Odebrat sloupec osy x',
    Y_AXIS_ITEMS: 'Položky osy Y',
    ADD_CHART_LINE: 'Přidat čáru grafu',
    UNLOCK_HIERARCHY: 'Odemknout hierarchii',
    LOCK_HIERARCHY: 'Zamknout hierarchii',
    MATERIALIZE: 'Materializovat',
    MORE_OPTIONS: 'Více možností',
    LOCK_ROW: 'Zamknout řádek',
    LOCK_COLUMN: 'Zamknout sloupec',
    PASTE: 'Vložit',
    COPY: 'Kopírovat',
    CUT: 'Vyjmout',
    PASTE_ROWS: 'Vložit řádek(y)',
    COPY_ROWS: 'Kopírovat řádek(y)',
    CUT_ROWS: 'Vyjmout řádek(y)',
    MOVING_ROWS: 'Přesouvání řádků...',
    PASTING_ROWS: 'Vkládání řádků...',
    CONFIRM_LOCK: 'Potvrdit zamknutí',
    CONFIRM_UNLOCK: 'Potvrdit odemknutí',
    CONFIRM_LOCK_AND_CHILDREN: 'Jste si jisti, že chcete zamknout tento řádek a jeho podřízené?',
    CONFIRM_UNLOCK_AND_CHILDREN: 'Jste si jisti, že chcete odemknout tento řádek a jeho podřízené?',
    SEARCH_FOR_IMPORTS: 'Hledat importy',
    NEW_IMPORT: 'Nový import',
    IMPORTER: 'Importér',
    CREATION_DATE: 'Datum vytvoření',
    ACTIONS: 'Akce',
    ADD_ACTION: 'Přidat akci',
    ADD_ARGUMENT: 'Přidat argument',
    EDIT_ACTION: 'Upravit akci',
    ACTION_NAME: 'Název akce',
    ARCHIVE: 'Archivovat',
    REPLACE: 'Nahradit',
    STATUS_MESSAGE_MAP: {
        'In progress': 'Probíhá',
        Commited: 'Spácháno',
        Archived: 'Archivováno',
        Reverted: 'Vráceno',
    },
    EDIT_TILE: 'Upravit dlaždici',
    FOCUS_TILE: 'Zaměřit dlaždici',
    UNFOCUS_TILE: 'Zrušit zaměření dlaždice',
    MOVE_TO: 'Přesunout do',
    ADD_ROW: 'Přidat řádek',
    ADD_COLUMN: 'Přidat sloupec',
    EDIT_ROW: 'Upravit řádek',
    FROM: 'Od',
    TO: 'Do',
    GLOBAL_FORMATTING: 'Globální formátování',
    FAIL_SAVE_CHANGES: 'Nepodařilo se uložit změny',
    TAG_NAME_EXISTS: 'Název značky již existuje.',
    MUST_CHOOSE_TYPE: 'Musíte vybrat typ',
    MUST_ENTER_TAG_NAME: 'Musíte zadat název značky',
    TAG_NAME_CANT_CONTAIN_QUOTATION_MARKS: 'Název značky nesmí obsahovat uvozovky',
    INVALID_VARIABLE_TAG_FORMAT: 'Neplatný formát značky proměnné: {tagFormat}',
    INVALID_FORMULA: 'Neplatný vzorec',
    FUNCITON_NOT_ALLOWED_ON_DIMENSION_TAGS: 'Funkce {image} není povolena na značkách dimenzí.',
    CREATE_DATABASE_OBJECT: 'Vytvořit objekt databáze',
    EDIT_TAG_TYPE_NAME: 'Upravit {tagType} "{tagName}"',
    PARENT: 'Rodič',
    ROOT: 'Kořen',
    SEARCH_OR_SELECT_PARENT_TAG: 'Hledat nebo vybrat nadřazenou značku',
    ROLLUP_TYPE: 'Typ agregace',
    DATA_TYPE: 'Typ dat',
    FORMAT_TYPE: 'Typ formátu',
    CHOOSE_FORMATTING_OPTION: 'Vyberte možnost formátování',
    ENTER_CUSTOM_FORMAT: 'Zadat vlastní formát',
    CUSTOM_FORMAT: 'Vlastní formát',
    TOP_DOWN: 'Shora dolů',
    TOP_DOWN_DATA_MAPPING: 'Mapa dat shora dolů',
    CONNECTED: 'Připojeno',
    ADD_CONNECTED_VARIABLE: 'Přidat připojenou proměnnou',
    REVERSE_CONNECTED: 'Reverzně připojeno',
    ADD_REVERSE_CONNECTED_VARIABLE: 'Přidat reverzně připojenou proměnnou',
    DIMENSIONS: 'Dimenze',
    ADD_DIMENSION: 'Přidat dimenzi',
    ADVANCED: 'Pokročilý',
    CALCULATE_ON_DEMAND: 'Vypočítat na vyžádání',
    TRIGGER_ON_DEMAND_CALCULATION: 'Pro spuštění výpočtu na vyžádání, jděte do "Nastavení vstupu"',
    OPTIMIZE_CALCULATION: 'Optimalizovat výpočet',
    CONSTRAINED_LIGHT_TOP_DOWN: 'Omezený lehký shora dolů',
    USE_HIERARCHY_IN_CALCULATION: 'Použít hierarchii ve výpočtu',
    MAPPING_TO_VARIABLE: 'Mapování na proměnnou',
    ADD_FROM_VERSION: 'Přidat z verze',
    MAPPING_FROM_VERSION: 'Mapování z verze',
    MAPPING_TO_VERSION: 'Mapování na verzi',
    ADD_TO_VERSION: 'Přidat do verze',
    USED_IN_FORMULA: 'Používá se v 1 vzorci',
    USED_IN_FORMULAS: 'Používá se ve {numberOfTags} vzorcích',
    TABLE_BACKLINKS: 'Odkazuje se z {{1 tabulky|?? tabulek}}',
    VARIABLE_BACKLINKS: 'Používá se v {{1 proměnné|?? proměnných}}',
    ACTIVE: 'Aktivní',
    CONNECTED_DIMENSION: 'připojenou dimenzi',
    MY_ACCOUNT: 'Můj účet',
    SIGN_OUT: 'Odhlásit se',
    LOG_OUT: 'Odhlásit se',
    EDIT_PROFILE: 'Upravit profil',
    FARSEER_AI: 'FarseerAI',
    FARSEER_LABS: 'Farseer Labs',
    DATA_HUB: 'Data Hub',
    DATASETS: 'Datové sady',
    PIPELINES: 'Pipelines',
    NAMESPACE: 'Jmenný prostor',
    SEARCH_FOR_DATASETS: 'Hledat datové sady',
    NO_DATASETS_YET: 'Zatím žádné datové sady. Datové sady se vytvářejí, když se pipeline spouští s ukládáním datových sad.',
    SEARCH_FOR_PIPELINES: 'Hledat pipeline',
    NO_PIPELINES_YET: 'Zatím žádné pipeline. Pipeline je aplikace, která běží na běžci pipeline.',
    PROFILE_AND_SUPPORT: 'Profil a podpora',
    RENAME_TABLE: 'Přejmenovat tabulku',
    SHARE_TABLE: 'Sdílet tabulku',
    DELETE_TABLE_DATA: 'Smazat data tabulky',
    DELETE_TABLE_MEMBERS: 'Smazat členy tabulky',
    DELETE_TABLE_DIMENSIONS: 'Smazat dimenze tabulky',
    DELETE_TABLE: 'Smazat tabulku',
    DELETE_ROW: 'Smazat řádek',
    DELETE_ROWS: 'Smazat řádky',
    SHOW_VALUE: 'Zobrazit hodnotu',
    SHOW_VARIABLES_AND_DIMENSIONS: 'Zobrazit proměnné a dimenze',
    FREEZE_PANES: 'Ukotvit příčky panelů',
    FREEZE_UP_TO_THIS_ROW: 'Ukotvit až po tento řádek',
    FREEZE_UP_TO_THIS_COLUMN: 'Ukotvit až po tento sloupec',
    UNFREEZE_ROWS: 'Zrušit ukotvení řádků',
    UNFREEZE_COLUMNS: 'Zrušit ukotvení sloupců',
    HIDE_GRIDLINES: 'Skrýt mřížku',
    HIDE_ROW_COLUMN_HEADERS: 'Skrýt záhlaví řádků/sloupců',
    LABELS: 'Štítky',
    ADD_LABEL: 'Přidat štítek',
    ERROR_LABEL_EXISTS: 'Štítek již existuje!',
    ERROR_RENAMING_IMPORT_JOB_LABEL: 'Chyba při přejmenování štítku importní úlohy!',
    IMPORT_JOB_LABEL_RENAMED: 'Štítek importní úlohy přejmenován',
    ERROR_DELETING_IMPORT_JOB_LABEL: 'Chyba při mazání štítku importní úlohy!',
    IMPORT_JOB_LABEL_DELETED: 'Štítek importní úlohy smazán',
    CREATE_OR_SEARCH: 'Vytvořit nebo vyhledat..',
    CREATE: 'Vytvořit',
    NAME_AND_DESCRIPTION: 'Název a popis',
    SUBTOTALS: 'Subtotály',
    TOTAL: 'Celkem',
    DISABLED: 'Zakázáno',
    BEFORE: 'Před',
    AFTER: 'Po',
    UNSELECT_ALL: 'Zrušit výběr',
    SAVE_CONFIG_FOR_ALL: 'Uložit pro všechny',
    SAVE_CONFIG_FOR_ALL_TOOLTIP: 'Uložit změny konfigurace jako výchozí',
    EDIT_DIMENSION_SLICER: 'Úprava řezání rozměrů "{title}"',
    CREATE_DIMENSION_SLICER: 'Vytvořit nový rozměr řezání',
    ENABLE_MULTISELECT: 'Povolit více výběrů',
    DISPLAY_MULTIPLE_VALUES: 'Zobrazit více hodnot',
    SEARCH_AND_AUTO_SELECT: 'Hledat a automaticky vybrat',
    BLANKS: '(Prázdné)',
    ENTER_TITLE: 'Zadejte nadpis...',
    TAG_NAME_DISPLAY: 'Zobrazení názvu štítku',
    FILTERS: 'Filtry',
    ADD_FILTER: 'Přidat filtr',
    BY_DIMENSION: 'Podle rozměru',
    SHOW_ONLY_DIMENSIONS_WITH_DATA_IN: 'Zobrazit pouze rozměry s daty',
    EDIT_SINGLE_VALUE: 'Úprava jednotlivé hodnoty "{title}"',
    CREATE_SINGLE_VALUE: 'Vytvořit novou jednotkovou hodnotu',
    LEAVE_EMPTY_FOR_AUTOGENERATED: 'Nechte prázdné pro automatické generování',
    FILTER_DIMENSIONS: 'Filtrovat rozměry',
    COMPARISON_DIMENSIONS: 'Porovnávací rozměry',
    COMPARISON_CUSTOM_TEXT: 'Přizpůsobené srovnávací text',
    DATA_ENTRY: 'Vstup dat',
    SHOW_BUTTONS: 'Zobrazit tlačítka',
    STEP: 'Krok',
    AND: 'a',
    OR: 'NEBO',
    DOWNSTREAM_FILTERS: 'Dolejší filtry',
    TO_TABLE: 'Do tabulky',
    FROM_TABLE: 'Z tabulky',
    ADD_DOWNSTREAM_FILTER: 'Přidat dolní filtr',
    FLAT: 'Ploché',
    HIERARCHY_MAX_DEPTH: 'Hloubka hierarchie',
    APPLICATION_VERSION: 'Verze aplikace',
    CONFIRM_TAG_REMOVE: 'Potvrďte odebrání štítku',
    CONFIRM_TAGS_REMOVE: 'Potvrďte odebrání štítků',
    REMOVE_TAG_CONFIRMATION: 'Jste si jisti, že chcete odstranit značku {tagName}?',
    REMOVE_TAGS_CONFIRMATION: 'Jste si jisti, že chcete odstranit značky: {tagNames}?',
    REMOVE_TAGS_NUMBER_CONFIRMATION: 'Jste si jisti, že chcete odstranit {tagNumber} značky?',
    ERROR_PARSING_NUMBER: 'Chyba při zpracování čísla',
    ERROR_PARSING_DATE: 'Chyba při zpracování data',
    USE_CONTEXT_MENU_FOR_UPDATING_FILE_COLUMN: 'Použijte kontextové menu pro aktualizaci sloupce souboru',
    ERROR_PARSING_INPUT_NUMBER: 'Chyba při zpracování vstupního čísla',
    ERROR_SAVING_DATA: 'Chyba při ukládání dat',
    DATA_ENTRY_NOT_ALLOWED: 'Zápis dat není povolen',
    ERROR_PARSING_STEP_VALUE: 'Chyba při zpracování hodnoty kroku',
    TAG_NAME_CELLS: '{tagName}: {cellNumber} buňky',
    UNKNOWN_VARIABLE_CELLS: 'Neznámá proměnná: {cellNumber} buňky',
    SUCCESS_IMPORTED_CELLS: 'Úspěch! Importované buňky: {accountTags}',
    IMPORTED_CELLS: 'Importované buňky',
    IMPORT_JOB_DELETING: 'Mazání importní úlohy',
    IMPORT_JOB_DELETING_CONFIRM: 'Opravdu chcete smazat importní úlohu {importJobName}?',
    DELETE_AND_KEEP_DATA: 'Smazat a ponechat data',
    DELETE_JOB_AND_DATA: 'Smazat úlohu a data',
    ADD_DIMENSIONS_TO_JOB: 'Přidat rozměry k úloze',
    CONFIGURE: 'Konfigurovat',
    ADD_DESCRIPTION_FOR_IMPORT: 'Přidat popis pro tento import',
    UNDO: 'Vrátit změny',
    SETTINGS: 'Nastavení',
    BASIC_SETTINGS: 'Základní nastavení',
    OTHER_SETTINGS: 'Další nastavení',
    TABLE_NAME: 'Název tabulky',
    AUTOGENERATE_DIMENSION_NAMES: 'Automatické generování jmen dimenzí',
    AUTOGENERATE_NAMES_CONFIG: 'Konfigurace automatického generování jmen',
    AUTOGENERATE_NAMES_CONFIG_EXAMPLE: 'např. {SSS}-{YY}#{DD}',
    CUSTOM_TEMPLATE_DESCRIPTION: 'Definujte vlastní konfiguraci pro automatické generování jmen pro tuto tabulku. Použijte předdefinované tokeny níže s kučeravými závorkami. Mezi tokeny můžete vložit libovolný znak.',
    USE_TOKENS_TO_DEFINE_CONFIG: 'Můžete použít tyto tokeny pro definici konfigurace',
    AUTOGENERATE_CONFIG_EXAMPLE: '{SSS}-{YY}#{MM}_{DD}',
    AUTOGENERATE_CONFIG_EXAMPLE_DATE: '- 001-23#03_20 (března 20, 2023)',
    ENTRY: 'Vstup',
    STEP_MUST_BE_NUMBER: 'Krok musí být číslo',
    EDIT_DATA_EDITOR: 'Úprava editoru dat "{title}"',
    BUTTON_CONTROLS: 'Ovládací tlačítka',
    BOLD: 'Tučné',
    ITALIC: 'Kurzíva',
    UNDERLINED: 'Podtržené',
    OUTLINED: 'Obrys',
    FONT_SIZE: 'Velikost písma',
    FILE_SIZE: 'Velikost souboru',
    SMALL: 'Malý',
    MEDIUM: 'Střední',
    LARGE: 'Velký',
    CREATE_NEW_COLUMN: 'Vytvořit nový sloupec',
    EDIT_COLUMN_WITH_LABEL: 'Upravit sloupec "{label}"',
    COLUMN_TAGS: 'Štítky sloupce',
    DELETE_THIS_COLUMN: 'Smazat tento sloupec',
    SELECT_PARENT_TAG_TO_GENERATE_COLUMNS: 'Vyberte rodičovskou značku pro generování více sloupců',
    USING_SHARED_COLUMN_CONFIG: 'Použití sdílené konfigurace sloupce',
    SLICER_GENERATED: 'Slicer generován',
    HEADER_CANNOT_BE_EMPTY: 'Hlavička nesmí být prázdná',
    MUST_CHOOSE_A_FORMAT: 'Musíte vybrat formát',
    CALCULATION_FIELDS_CANT_BE_EMPTY: 'Pole pro výpočet nemůže být prázdné',
    ADD_NEW_COLUMN: 'Přidat nový sloupec',
    HEADER: 'Hlavička',
    SUBHEADER: 'Podtitulek',
    TYPE: 'Typ',
    POLARITY: 'Polarita',
    CONDITIONAL_FORMATTING: 'Podmíněné formátování',
    CONDITIONAL_FORMATTING_TYPE_OPTIONS: {
        Relative: 'Relativní',
        Absolute: 'Absolutní',
    },
    CONDITIONAL_FORMATTING_POLARITY_OPTIONS: {
        Positive: 'Pozitivní',
        Negative: 'Negativní',
        Neutral: 'Neutrální',
    },
    KPI_COLUMN_TYPE_META: {
        Regular: 'Běžný',
        Calculated: 'Kalkulovaný',
    },
    CONDITIONAL_FORMATTING_OPTIONS: {
        Off: 'Vypnuto',
        Traffic: 'Semafory',
        Databar: 'Databar',
        Colorscale: 'Barevná škála',
        Arrows: 'Šipky',
    },
    HIDE_NUMBERS: 'Skrýt čísla',
    COLUMN_ONE: 'Sloupec 1',
    COLUMN_TWO: 'Sloupec 2',
    LITERAL: 'literal',
    FUNCTION: 'funkce',
    FUNCTIONS: 'Funkce',
    EXAMPLE: 'Příklad',
    EDIT_IN: 'Upravit {type}',
    OPEN_IN_EDITOR: 'Otevřít v {type} editoru',
    REMOTE_JOBS_DATE_TIME_MESSAGE: 'Každý týden v {day} v {time}',
    REMOTE_JOB_SCHEDULED: 'Naplánováno {schedule}',
    SCHEDULE: 'Plán',
    EVERY: 'Každý',
    EVERY_HOUR_AT: 'Každou hodinu v',
    EVERY_DAY_AT: 'Každý den v',
    RUN_JOB: 'Spustit úlohu',
    RUN: 'Spustit',
    APP_WITH_ID: 'Aplikace č. {id}',
    PIPELINE_RUNS_LOAD_FAILED: 'Nepodařilo se načíst spuštění této aplikace.',
    PIPELINE_RUN_NOT_FOUND: 'Spuštění č. {runId} není v historii spuštění této aplikace.',
    PIPELINE_SHOW_LATEST_RUN: 'Zobrazit nejnovější spuštění',
    PIPELINE_OUTPUT: 'Výstup',
    PIPELINE_OUTPUT_IN_FILES: 'Uloženo v souborech. Toto úložiště uchovává pouze nejnovější výstup, nikoli výstup každého spuštění.',
    PIPELINE_OUTPUT_STATE_MAP: {
        published: 'Publikováno tímto spuštěním',
        completed: 'Zapsáno tímto spuštěním, nepublikováno',
        started: 'Zahájeno tímto spuštěním, nedokončeno',
    },
    PIPELINE_OUTPUT_BEING_WRITTEN: 'Zapisováno tímto spuštěním',
    PIPELINE_OUTPUT_NOT_RECORDED: 'Datová sada s názvem tohoto kroku existuje. Toto spuštění nezaznamenalo její zápis, takže se otevře její aktuální verze.',
    PIPELINE_PEEK_TOO_LARGE: 'Tato verze je pro rychlý náhled příliš velká. Otevřete tuto verzi a zobrazte její náhled.',
    PIPELINE_PEEK_EMPTY: 'Tato verze neobsahuje žádné řádky.',
    PIPELINE_PEEK_FIRST_ROWS: 'Prvních {shown} z {total} řádků',
    PIPELINE_PEEK_ALL_ROWS: 'Všech {total} {{řádek|řádky}}',
    PIPELINE_OUTPUT_PAYLOAD: 'Soubor ze zdroje, jak jej toto spuštění uložilo, uchovávaný 30 dní',
    PIPELINE_PAYLOAD_PEEK_TOO_LARGE: 'Tento soubor je pro rychlý náhled příliš velký. Stáhněte jej a otevřete.',
    PIPELINE_PAYLOAD_PEEK_EMPTY: 'Tento soubor neobsahuje žádné řádky.',
    PIPELINE_PAYLOAD_NO_PEEK: 'Soubory {format} nemají rychlý náhled. Jejich data zobrazí krok, který tento soubor parsuje.',
    OPEN_IN_FILES: 'Otevřít v Souborech',
    PIPELINE_SELECT_STEP: 'Vyberte krok v grafu, aby se zobrazily jeho podrobnosti.',
    PIPELINE_WAITING_FOR_STEPS: 'Toto spuštění zatím nezaznamenalo žádný krok.',
    RUN_LOGS: 'Protokoly spuštění',
    PIPELINE_STEP_NOT_IN_RUN: '{step} není v tomto spuštění.',
    QUEUED: 'Ve frontě',
    RUNNING: 'Běží',
    UNAVAILABLE: 'Nedostupné',
    MINUTES: 'minuty',
    JOBS: 'Úlohy',
    JOB_LOGS: 'Protokoly úloh',
    PREFERRED_RUNNER: 'Preferovaný běžec',
    RUNNER_DISCONNECTED: 'Tento běžec je momentálně odpojen.',
    RUNNER_IMAGE: 'Obraz běžce',
    WHERE_RUNS_HAPPEN: 'Kde probíhají běhy',
    COMPUTE_SHARED_RUNNER: 'Na sdíleném běžci',
    COMPUTE_OWN_MACHINE_SIZE: 'Vlastní stroj ({size})',
    COMPUTE_OWN_MACHINE_DEFAULT_SIZE: 'Vlastní počítač (výchozí velikost)',
    COMPUTE_WARNING: {
        nothingConnected: 'Není připojen žádný běžec, takže není známo, kde se tato úloha může spustit.',
        namedRunnerNotConnected: 'Běžec zadaný pro tuto úlohu není připojen, takže není známo, kde se tato úloha může spustit.',
        namedRunnerOffersNoOwnMachine: 'Běžec zadaný pro tuto úlohu nemůže vytvořit stroj, takže tato úloha nebude spuštěna.',
        noRunnerOffersOwnMachine: 'Žádný připojený běžec nemůže vytvořit stroj, takže tato úloha nebude spuštěna.',
        namedRunnerOffersNoSharedRun: 'Běžec zadaný pro tuto úlohu spouští úlohy pouze na svém vlastním stroji, takže tato úloha nebude spuštěna.',
        noRunnerOffersSharedRun: 'Žádný připojený běžec nespouští úlohy na sdíleném běžci, takže tato úloha nebude spuštěna.',
        namedRunnerOffersNothing: 'Běžec zadaný pro tuto úlohu spouští úlohy pouze na svém vlastním stroji a nemůže žádný vytvořit, takže tato úloha nebude spuštěna.',
        noRunnerOffersAnything: 'Žádný připojený běžec nespouští úlohy na sdíleném běžci a žádný nemůže vytvořit stroj, takže tato úloha nebude spuštěna.',
    },
    RUNNER_IMAGE_TAG: 'Verze',
    LOGS: 'Záznamy',
    REMOTE_JOBS: 'Aplikace',
    TAG_INTERNAL_TYPE_NAME: {
        Version: 'Verze',
        Year: 'Rok',
        Month: 'Měsíc',
        Quarter: 'Čtvrtletí',
        'Half Year': 'Pololetí',
        'Year to Date': 'Od začátku roku',
    },
    VARIABLE_TABLE_DIMENSION_GROUP: 'Proměnná/Tabulka/Dimenze/Skupina',
    ADD_NEW_VARIABLE_TABLE_DIMENSION_GROUP: 'Přidat nový {item}',
    DATA_TYPE_ENUM: {
        Integer: 'Celé číslo',
        Decimal: 'Desetinné číslo',
    },
    DEFAULT_FORMAT_TYPE_ENUM: {
        Custom: 'Vlastní',
        Number: 'Číslo',
        Currency: 'Měna',
        Percentage: 'Procento',
        Date: 'Datum',
    },
    HEADER_NAVIGATION: {
        Dashboard: 'Dashboard',
        Sheets: 'sheety',
        Import: 'Import',
        'Remote jobs': 'Aplikace',
        Dimensions: 'Rozměry',
    },
    ENTITY_TYPE: {
        DIMENSION_TABLE: 'Tabulka dimenzí',
        DIMENSION_MEMBER: 'Člen dimenze',
        VARIABLE: 'Proměnná',
        FOLDER: 'Složka',
        FUNCTION: 'Funkce',
        LITERAL: 'Literál',
        PROPERTY: 'Vlastnost',
        FILE: 'Soubor',
        DASHBOARD: 'Dashboard',
        REMOTE_JOB: 'Aplikace',
        SHEET: 'List',
        TILE: 'Dlaždice',
    },
    ENTITY_TYPES: {
        DIMENSION_TABLE: 'Tabulky dimenzí',
        DIMENSION_MEMBER: 'Členové dimenzí',
        VARIABLE: 'Proměnné',
        FOLDER: 'Složky',
        FUNCTION: 'Funkce',
        LITERAL: 'Literály',
        PROPERTY: 'Vlastnosti',
        FILE: 'Soubory',
        DASHBOARD: 'Dashboardy',
        REMOTE_JOB: 'Aplikace',
        SHEET: 'Listy',
        TILE: 'Dlaždice',
    },
    ITEM: 'Položka',
    ITEM_TYPE: 'Typ položky',
    FOLDER_ITEM: {
        DASHBOARD: 'Dashboard',
        DIMENSION_TABLE: 'Tabulka dimenzí',
        VARIABLE: 'Proměnná',
        SHEET: 'Sheet',
        FOLDER: 'Složka',
        FARSEER_FILE: 'Soubor',
        REMOTE_JOB: 'Aplikace',
    },
    FOLDER_ITEMS: {
        DASHBOARD: 'Dashboardy',
        DIMENSION_TABLE: 'Tabulky dimenzí',
        VARIABLE: 'Proměnné',
        SHEET: 'Sheety',
        FOLDER: 'Složky',
        FARSEER_FILE: 'Soubory',
        REMOTE_JOB: 'Aplikace',
    },
    TABLE_SETTINGS_TEMPLATE_PATTERNS: {
        UUID: 'generuje univerzální unikátní identifikátor',
        YYYY: 'vloží aktuální rok',
        YY: 'vloží poslední dvě číslice aktuálního roku',
        MM: 'vloží aktuální měsíc',
        DD: 'vloží aktuální den',
        SSSSSSSS: 'umístí sériové číslo z aktuální délky dětí tabulky + 1, délku definujte počtem znaků „S“ (1-8)',
    },
    CONFIG_MENU_SECTIONS: {
        'Users & Permissions': 'Uživatelé a oprávnění',
        'Users & Groups': 'Uživatelé a skupiny',
        System: 'Systém',
        'Input Setup': 'Nastavení vstupu',
        Locks: 'Uzamčení',
        'Backup & Restore': 'Záloha a obnova',
        'Audit Logs': 'Auditovací záznamy',
        'Export Model': 'Export modelu',
        'Import Model': 'Import modelu',
        'Switch Tenants': 'Přepnout pracovní prostor',
        Support: 'Podpora',
        'Help Center': 'Nápověda',
        'Contact Support': 'Kontaktovat podporu',
    },
    KPI_COLUMN_OPERATIONS: {
        minus: 'mínus',
        divide: 'dělit',
        plus: 'plus',
        multiply: 'násobit',
        percent: 'procento',
        'percent thousands': 'procent tisíc',
        'difference in %': 'rozdíl v %',
    },
    STATUS_MAP: {
        Resolved: 'Vyřešeno',
        Unresolved: 'Nerezolováno',
        'In Review': 'Ve zpracování',
        QUEUED: 'Ve frontě',
        RUNNING: 'Spuštěno',
        FINISHED: 'Dokončeno',
        ERROR: 'Chyba',
    },
    USER_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create User': 'Vytvořit uživatele',
        'Delete User': 'Smazat uživatele',
        'Find All Users': 'Najít všechny uživatele',
        'Get User': 'Získat uživatele',
        'Update User': 'Aktualizovat uživatele',
    },
    FEATURE_PERMISSIONS_TITLE_MAP: {
        TAGS_IN_MODEL: 'Objekty databáze v modelu',
        CLUSTER_FLOW_ADD: 'Přidat řádek',
        YEAR_VERSION_LOCKS: 'Uzamčení',
        IMPORT: 'Importovat',
        SEE_ALL_IMPORT_JOBS: 'Zobrazit všechny importní úlohy',
        USERS_GROUPS_MANAGEMENT: 'Správa uživatelů a skupin',
        REMOTE_JOBS: 'Aplikace',
        COMMENTS: 'Komentáře',
        TAGS_SIDEBAR: 'Boční panel s databází',
        CREDENTIALS: 'Přihlašovací údaje',
        INPUT_SETUP: 'Nastavení vstupu',
        AUDIT_LOGS: 'Zobrazit protokoly',
        ASSIGNMENTS: 'Úkoly',
        BACKUP_AND_RESTORE: 'Zálohování a obnova',
        DASHBOARD_TO_IMAGE: 'Převést dashboard na obrázek',
        CHAT_AI: 'Chat AI',
        DELETE_DIMENSION: 'Smazat dimenzi',
        FORECAST: 'Předpověď',
        GOAL_SEEKING_TOP_DOWN: 'Hledání cíle shora dolů',
        MODEL_IMPEX: 'Import/export modelu',
        OWD_MEASURES: 'Pouze s daty pro míry',
        FORMULA_QA: 'Kontrola vzorců',
        USE_HIERARCHY_IN_CALCULATION: 'Aktualizovat "použít hierarchii" v proměnných',
        MODEL_HEALTH: 'Zdraví modelu',
        FARSEER_LABS: 'Farseer Labs',
        FARSEER_LOGO: 'Logo Farseer',
        SHARED_WITH_ME: 'Sdíleno se mnou',
        API_KEY_MANAGEMENT: 'Správa API klíčů',
        DATA_HUB: 'Data Hub (čte všechny datové sady)',
    },
    CELL_CLASS_PERMISSIONS_TITLE_MAP: {
        'Edit Cells': 'Upravit buňky',
    },
    FOLDER_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Folder': 'Vytvořit složku',
        'Duplicate Folder': 'Duplikovat složku',
        'Search Folders': 'Vyhledávání složek',
        'Get Items in Folder': 'Získat položky ve složce',
        'Find by Reverse References': 'Najít podle zpětných odkazů',
        'Move Items': 'Přesunout položky',
        'Rename Items': 'Přejmenovat položky',
        'Delete Items in Folder': 'Smazat položky ve složce',
        'Share Folder Hierarchy': 'Sdílet hierarchii složky',
    },
    TAG_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Database Object': 'Vytvořit objekt databáze',
        'Delete Database Object': 'Smazat objekt databáze',
        'Get Database Object': 'Získat objekt databáze',
        'Update Database Object': 'Aktualizovat objekt databáze',
        'Search Database Objects': 'Prohledávat databázové objekty',
    },
    SHEET_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Sheet': 'Vytvořit sheet',
        'Get Sheet': 'Získat sheet',
        'Update Sheet': 'Aktualizovat sheet',
        'Duplicate Sheet': 'Duplikovat sheet',
        'Search Rows in Sheet': 'Vyhledat řádky v sheetu',
        'Get Sheet Data': 'Získat data o sheetu',
        'Set Sheet Data': 'Nastavit data sheetu',
    },
    SHEET_ROW_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Row': 'Vytvořit řádek',
        'Update Row': 'Aktualizovat řádek',
        'Delete Row': 'Smazat řádek',
        'Move Row': 'Přesunout řádek',
        'Duplicate Row': 'Duplikovat řádek',
        'Find All Row': 'Najít všechny řádky',
        'Get Row': 'Získat řádek',
        'Materialize Row': 'Materializovat řádek',
    },
    SHEET_LINE_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Line': 'Vytvořit linku sheetu (řádek nebo sloupec)',
        'Update Line': 'Aktualizovat linku sheetu',
        'Delete Line': 'Smazat linku sheetu',
        'Duplicate Line': 'Duplikovat linku sheetu',
        'Materialize Line': 'Materializovat linku sheetu',
        'Get Line': 'Získat linku sheetu',
    },
    SHARE_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Share': 'Vytvořit úkol',
        'Add Public Shares': 'Vytvořit veřejný úkol',
        'Delete Share': 'Smazat úkol',
        'Get Share': 'Získat úkol',
        'Update Share': 'Aktualizovat úkol',
    },
    LABEL_CLASS_PERMISSIONS_TITLE_MAP: {
        'Get Label': 'Získat štítek',
        'Create Label': 'Vytvořit štítek',
        'Update Label': 'Aktualizovat štítek',
        'Delete Label': 'Smazat štítek',
    },
    FARSEER_FILE_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create File': 'Vytvořit soubor',
        'Update File': 'Aktualizovat soubor',
        'Delete File': 'Smazat soubor',
        'Find All Files': 'Najít všechny soubory',
        'Get File': 'Získat soubor',
    },
    REMOTE_JOB_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Remote Job': 'Vytvořit aplikaci',
        'Update Remote Job': 'Aktualizovat aplikaci',
        'Find All Remote Jobs': 'Najít všechny aplikace',
        'Get Remote Job': 'Získat aplikaci',
        'Run Remote Job': 'Spustit aplikaci',
        'Run Remote Job As A Service': 'Spustit aplikaci jako službu',
    },
    OVERSEER_CLASS_PERMISSIONS_TITLE_MAP: {
        'Restore Backup': 'Obnovit zálohu',
        'Create Backup': 'Vytvořit zálohu',
        'Search Backups': 'Vyhledat zálohy',
        'Download Backup': 'Stáhnout zálohu',
        'Upload Backup': 'Nahrát zálohu',
    },
    MODEL_CLASS_PERMISSIONS_TITLE_MAP: {
        'Read Model': 'Číst model',
        'Edit Model': 'Upravit model',
    },
    SETTING_CLASS_PERMISSIONS_TITLE_MAP: {
        'Update Global Locks': 'Aktualizovat uzamčení',
        'Update Financial Year': 'Aktualizovat začátek finančního roku',
    },
    DASHBOARD_CLASS_PERMISSIONS_TITLE_MAP: {
        'Create Dashboard': 'Vytvořit nástěnku',
        'Duplicate Dashboard': 'Duplikovat nástěnku',
        'Find All Dashboards': 'Najít všechny nástěnky',
        'Get Dashboard': 'Získat nástěnku',
        'Update Dashboard': 'Aktualizovat nástěnku',
    },
    FEATURE_PERMISSION_TITLES: {
        FeaturePermission: 'Oprávnění pro funkci',
        FolderClassPermission: 'Oprávnění pro třídu složky',
        TagClassPermission: 'Oprávnění pro třídu značky',
        SheetClassPermission: 'Oprávnění pro třídu tabulky',
        SheetRowClassPermission: 'Oprávnění pro třídu řádku tabulky',
    },
    SEARCH_TAGS: 'Hledat značky...',
    SEARCH_PERMISSIONS: 'Hledat oprávnění',
    DEFAULT: 'Výchozí',
    FEATURE_PERMISSIONS: 'Oprávnění pro funkce',
    CLASS_PERMISSIONS: 'Oprávnění pro třídy',
    ADD_COMMENT: 'Přidat komentář',
    SORT: 'Řadit',
    SORT_BY: 'Řadit podle',
    ASCENDING: 'Vzestupně',
    DESCENDING: 'Sestupně',
    UNSORT: 'Neřadit',
    AUTO: 'Auto',
    LEFT: 'Vlevo',
    ALL_MONTHS: 'Všechny měsíce',
    TWELVE_MONTHS: '12 měsíců',
    YEAR_START: 'Začátek roku',
    TIMELINE_START: 'Začátek časové osy',
    COPY_HASH_TAG: 'Kopírovat #',
    SHOW_TOP: 'Zobrazit nejlepších',
    SHOW_REST: 'Zobrazit zbytek',
    RIGHT: 'Vpravo',
    CENTER: 'Střed',
    TOP: 'Nahoře',
    MIDDLE: 'Střed',
    BOTTOM: 'Dole',
    YEAR_END: 'Konec roku',
    TIMELINE_END: 'Konec časové osy',
    CURRENT_YEAR: 'Aktuální rok',
    PREVIOUS_YEAR: 'Předchozí rok',
    CUSTOM: 'Vlastní',
    NEW_TABLE: 'Nová {name}',
    EDIT_TABLE: 'Upravit {name}',
    FOCUS_TABLE: 'Zaměřit se na {name}',
    ROUND: 'Zaokrouhlit',
    REGRESSION: 'Regrese',
    RANDOM: 'Náhodný',
    SET_VALUE: 'Nastavit hodnotu',
    APPLY_PERCENTAGE: 'Použít procento',
    APPLY_PERCENTAGE_CHAR: 'Použít %',
    DELETE_COLUMNS_ON_ROW: 'Smazat sloupce na řádku',
    PROCESSING_FILE: 'Zpracování souboru',
    IMAGE_PREVIEW_FAILED: 'Náhled obrázku se nezdařil',
    NEXT: 'Další',
    PREVIOUS: 'Předchozí',
    PAGE_OF: 'Stránka {pageNumber} z {pages}',
    NO_TITLE: 'Bez názvu',
    DURATION: 'Trvání',
    CELL_COUNT: 'Počet buněk',
    NONCALCULATED: 'Nevypočteno',
    CALCULATED: 'Vypočteno',
    SEARCH_ASSIGNMENTS: 'Hledat úkoly',
    BY_NAME: 'Podle jména',
    BY_LABEL: 'Podle štítku',
    BY_STATUS: 'Podle stavu',
    BY_SHEET: 'Podle sheetu',
    GROUP_BY: 'Seskupit podle',
    CHART_SPACING: 'Rozestupy grafu',
    GRID_COLUMNS: 'Sloupce mřížky',
    GRID_SPACING: 'Rozestup mřížky',
    AXIS_SPACING: 'Rozestup os',
    RESET_FILTERS: 'Obnovit filtry',
    RESET_CONFIG: 'Obnovit nastavení',
    RESET_CONFIG_TOOLTIP: 'Obnovit konfiguraci',
    BY_ASSIGNEE: 'Podle přiřazence',
    BY_APPROVER: 'Podle schvalovatele',
    NEW_ASSIGNMENT: 'Nové úkoly',
    NEXT_ASSGN_DUE: 'Další úkol je splatný',
    SHARE_SELECT_USER_PLACEHOLDER: 'Vyhledat uživatele nebo skupiny...',
    CREATE_ASSIGNMENT_PLACEHOLDER: 'Vytvořit úkol vybráním uživatele...',
    ASSIGNMENT_REFRESHED: 'Úkol byl prodloužen o 7 dní',
    CANT_EDIT_ASSIGNMENT: 'Nelze upravit již odeslané úkoly',
    NO_CHANGES: 'žádné změny',
    APPROVED: 'Schváleno',
    EXPIRED: 'Vypršelo',
    READY_FOR_REVIEW: 'Připraveno k přezkoumání',
    IN_PROGRESS: 'Probíhá',
    SHARED: 'Sdíleno',
    SHARED_WITH: 'Sdíleno s',
    SHARED_WITH_ME: 'Sdíleno se mnou',
    SHARED_WITH_ME_TRUNCATED: 'Zobrazuje se pouze prvních {limit} sdílených položek',
    ARCHIVED: 'Archivováno',
    STILL_STUCK: 'Stále uvíznutí? Navštivte náš centrum pomoci.',
    NEED_HELP: 'Potřebujete pomoc? Navštivte náš centrum pomoci.',
    WELCOME: 'Vítejte',
    WELCOME_MESSAGE: 'Vyberte něco z postranního panelu k zahájení, nebo vyhledat něco konkrétního.',
    DEFAULT_MEMBER: 'Výchozí člen',
    FAILED_TO_LOAD_MODEL: 'Chyba při načítání modelu',
    MODEL_LOADED: 'Model načten',
    PREVIOUS_MESSAGE_IS_PROCESSING: 'Vaše předchozí zpráva se zpracovává. Počkejte, prosím...',
    RUN_ARGUMENTS: 'Spustit argumenty',
    EXPECTED_ARGUMENTS: 'Očekávané argumenty',
    RUN_ARGUMENTS_ERROR: 'Argumenty pro spuštění akce jsou zastaralé, prosím, aktualizujte je.',
    RUNS: 'Spuštění',
    PIPELINE: 'Pipeline',
    PIPELINE_TAB_NO_RUNS: 'Spusťte tuto aplikaci, aby se zobrazila její pipeline.',
    PIPELINE_TAB_NO_MARKERS: 'Spuštění této pipeline nezaznamenávají své kroky. Přidejte experimental__emit_pipeline_visualization_markers=True k run_pipeline v main.py.',
    PIPELINE_STEP_TYPE_MAP: {
        extraction: 'Extrakce',
        parse: 'Parsování',
        transform: 'Transformace',
        load: 'Načtení',
        export: 'Export',
        unknown: 'Krok',
    },
    PIPELINE_STEP_STATUS_MAP: {
        PENDING: 'Čeká',
        RUNNING: 'Probíhá',
        OK: 'Dokončeno',
        EXTRACTED: 'Extrahováno',
        LOADED: 'Načteno',
        EXPORTED: 'Exportováno',
        SKIPPED: 'Přeskočeno',
        FAILED: 'Selhalo',
    },
    PIPELINE_STEP_POSITION: 'Krok {index} z {total}',
    PIPELINE_STEP_ARIA_LABEL: 'Krok pipeline {name}, stav {status}',
    PIPELINE_QUALITY_WARNINGS: '{count} {{upozornění na kvalitu|upozornění na kvalitu}}',
    PIPELINE_DATASET_COUNT: '{count} {{datová sada|datové sady}}',
    PIPELINE_COMPLETED_IN: 'Dokončeno za {duration}',
    PIPELINE_STEPS_EXECUTED: 'Provedeno kroků: {done}/{total}',
    PIPELINE_STEPS_DONE: 'Dokončeno kroků: {done}/{total}',
    PIPELINE_FAILED_BEFORE_STEPS: 'Pipeline selhala před spuštěním jakéhokoli kroku: {error}',
    PIPELINE_NO_STEPS: 'Nebyly nalezeny žádné kroky pipeline',
    ROWS: 'Řádky',
    DEPENDS_ON: 'Závisí na',
    SOURCE: 'Zdroj',
    SECONDS_SHORT: '{seconds}s',
    SYSTEM: 'Systém',
    BASIC_INFO: 'Základní informace',
    LAST_RUN: 'Poslední spuštění',
    NEVER_RUN: 'Nikdy nezahájeno',
    REMOTE_JOB_NAME: 'Název aplikace',
    CHOOSE_FOLDER: 'Vyberte složku',
    SOURCE_FOLDER: 'Zdrojová složka',
    SELECT_SOURCE_FOLDER_WARNING: 'Vyberte prosím zdrojovou složku',
    MAIN_FILE_HINT: 'Klepněte na pilulku souboru, abyste označili skriptovací soubor jako vstupní bod',
    NO_FILES: 'Žádné soubory',
    NO_MAIN_FILE: 'Žádný hlavní soubor',
    FINDER_TOOLTIP: 'Zobrazit Finder',
    VARIABLE_TOOLTIP: 'Zobrazit lištu proměnných',
    sheet_ITEMS_TOOLTIP: 'Zobrazit položky sheetu',
    LIST_ITEMS_TOOLTIP: 'Zobrazit položky seznamu',
    EXPAND_TOOLTIP: 'Rozbalit všechny řádky o jeden level',
    COLLAPSE_TOOLTIP: 'Sbalit všechny řádky o jeden level',
    UNDO_TOOLTIP: 'Zpět',
    REDO_TOOLTIP: 'Znovu',
    UNDO_HISTORY_RESET: 'Historie vrácení zpět byla obnovena',
    UNDO_UNAVAILABLE_NOT_SUPPORTED: 'Tuto změnu nelze vrátit zpět',
    UNDO_UNAVAILABLE_TOO_LARGE: 'Tato změna je příliš velká na vrácení zpět',
    UNDO_UNAVAILABLE_NO_INVERSE: 'Vrácení zpět již není k dispozici',
    UNDO_UNAVAILABLE_NO_LONGER_ALLOWED: 'Tuto změnu již nelze vrátit zpět',
    UNDO_UNAVAILABLE_GENERIC: 'Tuto změnu nelze vrátit zpět',
    FORECAST_TOOLTIP: 'Zobrazit průběh předpovědi',
    EXPORT_TOOLTIP: 'Exportovat do .xlsx',
    APP_SHORTCUTS_TOOLTIP: 'Zkratky aplikací',
    TAGS_SIDEBAR_TOOLTIP: 'Otevřít postranní panel databáze',
    TILE_SIDEBAR_TOOLTIP: 'Otevřít postranní panel úprav dlaždic',
    COMMENTS_SIDEBAR_TOOLTIP: 'Otevřít postranní panel komentářů',
    ADD_APP_SHORTCUT: 'Přidat zkratku',
    APP_SHORTCUTS_PATH: 'Zkratky aplikací',
    CHANGE_SHORTCUT_ACTION: 'Změnit akci',
    REMOVE_SHORTCUT: 'Odebrat zkratku',
    SHORTCUT_ADDED: 'Zkratka úspěšně přidána',
    SHORTCUT_REMOVED: 'Zkratka odebrána',
    SHORTCUT_ALREADY_EXISTS: 'Zkratka již existuje',
    CHANGE_ACTION_TITLE: 'Změnit akci',
    CHANGE_ACTION_LABEL: 'Vyberte jednu z následujících akcí',
    ACTION_CHANGED: 'Akce změněna',
    ERROR_FETCHING_APP_DATA: 'Chyba při načítání dat aplikace',
    ERROR_FETCHING_ACTION_ARGUMENTS: 'Chyba při načítání argumentů akce',
    INVALID_ACTION_ARGUMENTS: 'Neplatné argumenty akce',
    APP_STARTED_SUCCESSFULLY: 'Aplikace úspěšně spuštěna',
    CREATE_BACKUP: 'Vytvořit zálohu',
    BACKUP: 'Záloha',
    CREATE_BACKUP_WARNING: 'Opravdu chcete vytvořit novou zálohu?',
    RESTORE_BACKUP: 'Obnovit zálohu',
    RESTORE: 'Obnovit',
    RESTORE_BACKUP_WARNING: 'Opravdu chcete obnovit zálohu {backupPath}?',
    COPY_WORKSPACE: 'Kopírovat pracovní prostor',
    SELECT_WORKSPACE: 'Vybrat pracovní prostor',
    COPY_WORKSPACE_ONTO: 'Kopírovat do {workspace}',
    COPY_WORKSPACE_WARNING: 'Vše v tomto pracovním prostoru bude nahrazeno kopií vybraného pracovního prostoru. Nejprve se vytvoří záloha tohoto pracovního prostoru a kopírování může trvat několik minut.',
    COPY_WORKSPACE_STARTED: 'Kopírování pracovního prostoru bylo zahájeno. Tento pracovní prostor bude až do dokončení nedostupný.',
    SELECT_MONTH: 'Vybrat měsíc',
    REMOVE_FILTER: 'Odstranit filtr',
    FILTER_BY: 'Filtrovat podle...',
    STATIC_FILTER: 'Tento filtr nelze upravit',
    SELECT_ROW_TO: 'Vyberte řádek k zobrazení nebo úpravě jeho proměnné',
    EDIT_ARGUMENT: 'Upravit argument',
    ARGUMENT_NAME: 'Název argumentu',
    DATA_TYPE_STRING: 'Řetězec',
    DATA_TYPE_BOOLEAN: 'Boolean',
    DEFAULT_VALUE: 'Výchozí hodnota',
    ADD_OPTION: 'Přidat možnost',
    OPTION_VALUE: 'Hodnota možnosti',
    DROPDOWN_OPTIONS_MUST_BE_UNIQUE: 'Možnosti musí být jedinečné',
    DROPDOWN_OPTION_EMPTY: 'Možnost nesmí být prázdná',
    DROPDOWN_DEFAULT_AUTO_HINT: 'Není vybrána výchozí hodnota — při uložení bude použita první možnost.',
    LOCKED_AT_RUN_TIME: 'Uzamknout hodnotu při běhu',
    LOCKED_AT_RUN_TIME_TOOLTIP: 'Pokud je zaškrtnuto, uživatelé spouštějící aplikaci nemohou tuto hodnotu změnit.',
    LOCKED_REQUIRES_DEFAULT: 'Uzamčený argument musí mít výchozí hodnotu',
    SECRET: 'Tajné',
    SECRET_TOOLTIP: 'Hodnota je maskována při zadávání a v protokolech',
    SECRET_SAVED_PLACEHOLDER: 'Ponechte prázdné pro uložený tajný údaj',
    NAME_REQUIRED: 'Název je povinný',
    BACKUP_CREATED: 'Záloha vytvořena',
    DOWNLOADING_BACKUP: 'Stahování zálohy',
    BACKUP_RESTORED: 'Záloha obnovena',
    BACKUP_SEARCH_FAILED: 'Načtení záloh se nezdařilo. Zkuste to prosím znovu.',
    UPLOAD_BACKUP: 'Nahrát zálohu',
    UPLOADING: 'Nahrávání',
    SHOW_UPLOADED: 'Zobrazit nahrané',
    INITIATED_BY: 'Iniciirano',
    SAVE_AS_IMAGE: 'Uložit jako obrázek',
    CREATING_AND_SAVING_IMAGE: 'Vytváření obrázku a ukládání do souborů...',
    IMAGE_SAVED: 'Obrázek uložen!',
    FAILED_TO_SAVE_IMAGE: 'Nezdařilo se uložit obrázek',
    GOAL_VALUE: 'Cílová hodnota',
    CURRENT_VALUE: 'Aktuální hodnota',
    PERCENTAGE_MET: 'Splněno {percentage}%',
    UNFREEZE_CELLS: 'Odemknout buňky',
    FREEZE_CELLS: 'Zamknout buňky',
    UNSET_GOAL: 'Zrušit jako cílovou hodnotu',
    SET_GOAL: 'Nastavit jako cílovou hodnotu',
    INSPECT_VALUE: 'Prohlédnout hodnotu',
    EDITING_TILE: 'Úprava dlaždice',
    NO_TILE_SELECTED: 'Prosím vyberte dlaždici.',
    NO_TILE_OPTIONS: 'Žádné možnosti k dispozici',
    TILE_NAME: 'Název dlaždice',
    ENTER_TILE_NAME: 'Zadejte název dlaždice',
    USE_FILTERS_FROM: 'Použít filtry z',
    USE_SORT_FROM: 'Použít řazení z',
    USE_TIMELINE_FROM: 'Použít časovou osu z',
    SHOW_TILE_SORT: 'Zobrazit řazení této dlaždice',
    SHOW_TILE_FILTERS: 'Zobrazit filtry dlaždice',
    SHOW_TILE_TIMELINE: 'Zobrazit časovou osu dlaždice',
    DASHBOARD: 'Dashboard',
    TILE: 'Dlaždice',
    TILE_COPIED: 'Dlaždice byla zkopírována!',
    CHART_COLUMN_OPTIONS: 'Možnosti sloupce',
    CHART_ROW_OPTIONS: 'Možnosti řádku',
    GENERAL_STYLING: 'Obecné stylizování',
    PER_ROW_STYLING: 'Stylizace na řádek',
    PER_COLUMN_STYLING: 'Stylizace na sloupec',
    TEXT_STYLE: 'Styl textu',
    ROW_STYLE: 'Styl řádku',
    COLOR: 'Barva',
    PALETTE: 'Paleta',
    BACKGROUND: 'Pozadí',
    BORDER: 'Ohraničení',
    SHADOW: 'Stín',
    TOP_BORDER: 'Horní ohraničení',
    BOTTOM_BORDER: 'Dolní ohraničení',
    INNER_BORDER: 'Vnitřní ohraničení',
    RESET_GENERAL_STYLES: 'Obnovit obecné styly',
    RESET_ALL_PER_ROW_STYLES: 'Obnovit všechny styly řádku',
    RESET_ALL_PER_COLUMN_STYLES: 'Obnovit všechny styly sloupce',
    RESET_STYLES: 'Obnovit styly',
    ADD_TABLE: 'Přidat tabulku',
    ADD_VARIABLE: 'Přidat proměnnou',
    ADD_SHEET: 'Přidat sheet',
    ADD_DASHBOARD: 'Přidat dashboard',
    ADD_APP: 'Přidat aplikaci',
    ADD_FILE: 'Přidat soubor',
    ADD_FOLDER: 'Přidat složku',
    ENABLED: 'Zapnuto',
    NEW_TEMPLATE: 'Nová šablona',
    EDIT_TEMPLATE: 'Upravit šablon',
    SAVE_SELECTION_AS_TEMPLATE: 'Uložit výběr jako šablonu',
    TEMPLATE_CREATED: 'Šablona vytvořena',
    TEMPLATE_UPDATED: 'Šablona aktualizována',
    TEMPLATE_DELETED: 'Šablona smazána',
    TEMPLATE_NAME: 'Název šablony',
    TEMPLATE_DESCRIPTION: 'Popis šablony',
    QUANTITY: 'Množství',
    ENTER_TEXT: 'Zadejte text',
    ENTER_NAME: 'Zadejte název',
    ENTER_DESCRIPTION: 'Zadejte popis',
    ENTER_NUMBER: 'Zadejte číslo',
    PICK_A_DATE: 'Vyberte datum',
    ERROR_CREATING_DIMENSION: 'Chyba při vytváření nové dimenze',
    ALLOW_MULTI_CREATE: 'Povolit vytvoření více položek najednou',
    ALLOW_NAME_DESC_CONN_ON_CREATE: 'Nastavit název, popis a propojení při vytváření',
    ALLOW_PROPERTIES_ON_CREATE: 'Nastavit vlastnosti při vytváření',
    NAMING_CONFIG_ENABLED: '(Konfigurace pojmenování zapnuta)',
    DIMENSION_TABLE: 'Tabulka dimenzí',
    DIMENSION_TABLES: 'Tabulky dimenzí',
    DIMENSION_MEMBER: 'Člen dimenze',
    DIMENSION_MEMBERS: 'Členové dimenze',
    ASK_WHEN_CREATING: 'Zeptejte se při vytváření',
    PREDEFINED_CONNECTIONS: 'Předdefinované připojení',
    REQUIRED: 'Vyžadováno',
    CHOOSE_A_TABLE_FIRST: 'Nejprve vyberte tabulku',
    BIND_TO_TIMELINE: 'Připoutat k časové ose',
    NEW_VARIABLE_COLUMN: 'Nový proměnný sloupec',
    NEW_DIMENSION_COLUMN: 'Nový dimenzionální sloupec',
    NEW_LOOKUP_COLUMN: 'Nový sloupec vyhledávání',
    NEW_COMPARISON_COLUMN: 'Nový srovnávací sloupec',
    EDITING_CUSTOM_COLUMN: 'Úprava vlastního sloupce',
    LOOKUP_PROPERTIES: 'Vlastnosti vyhledávání',
    CALCULATION_COLUMN: 'Výpočetní sloupec',
    ADD_COLUMNS: 'Přidat sloupce',
    COLUMN_NAME: 'Název sloupce',
    DELETE_CUSTOM_COLUMN_CONFIRMATION: 'Jste si jisti, že chcete tuto kolonu smazat?',
    AUTOGENERATED_CUSTOM_COLUMN_NAME: 'Ponechte prázdné pro automaticky generované jméno',
    NOTE_INSPECT_VALUE: 'Poznámka: Funkce prohlédnout hodnotu zobrazuje pouze prvních 500 řádků. Pro zobrazení všech dat exportujte celý datový soubor.',
    COPY_FROM: 'Kopírovat z',
    COPY_FROM_TAGNAME: 'Kopírovat z {tag}',
    PREVIEW: 'Náhled',
    DECIMALS: 'Desetinná místa',
    SIGNS: 'Záporná čísla',
    NEGATIVE_SIGNS: {
        SIGNED: 'Mínus',
        UNSIGNED: 'Bez znaménka',
        EXPLICIT: 'Plus/Mínus',
    },
    POLARITY_SIGNS: {
        POSITIVE: 'Kladné',
        NEGATIVE: 'Záporné',
    },
    BASE_UNIT: 'Základní jednotka',
    BASE_UNITS: {
        ONES: 'Jedničky',
        THOUSANDS: 'Tisíce',
        THOUSANDS_K: 'Tisíce (k)',
        MILLIONS: 'Miliony',
        MILLIONS_M: 'Miliony (m)',
        BILLIONS: 'Miliardy',
        BILLIONS_B: 'Miliardy (b)',
        AUTO: 'Automaticky',
    },
    CURRENCY_UNITS: {
        EUR: '€',
        USD: '$',
        HRK: 'HRK',
    },
    MONTHS: {
        January: 'Leden',
        February: 'Únor',
        March: 'Březen',
        April: 'Duben',
        May: 'Květen',
        June: 'Červen',
        July: 'Červenec',
        August: 'Srpen',
        September: 'Září',
        October: 'Říjen',
        November: 'Listopad',
        December: 'Prosinec',
    },
    MONTHS_SHORT: {
        Jan: 'Led',
        Feb: 'Úno',
        Mar: 'Bře',
        Apr: 'Dub',
        May: 'Kvě',
        Jun: 'Čer',
        Jul: 'Črc',
        Aug: 'Srp',
        Sep: 'Zář',
        Oct: 'Říj',
        Nov: 'Lis',
        Dec: 'Pro',
    },
    DAYS: {
        Sunday: 'Neděle',
        Monday: 'Pondělí',
        Tuesday: 'Úterý',
        Wednesday: 'Středa',
        Thursday: 'Čtvrtek',
        Friday: 'Pátek',
        Saturday: 'Sobota',
    },
    DAYS_SHORT: {
        Sun: 'Ne',
        Mon: 'Po',
        Tue: 'Út',
        Wed: 'St',
        Thu: 'Čt',
        Fri: 'Pá',
        Sat: 'So',
    },
    CURRENCY: 'Měna',
    SIGNING_IN: 'Přihlašování...',
    NEW_RELATION_COLUMN: 'Nový sloupec relace',
    SELECT_TABLE_LOOKUP: 'Vyberte tabulku pro vyhledávání',
    SELECT_TABLE_RELATION: 'Propojit členy řádku s',
    SELECT_TABLE_PROPERTY: 'Vyberte vlastnost z tabulky',
    DISPLAY_TABLE_PROPERTY: 'Zobrazit vlastnost z tabulky',
    FILTER_MEMBERS: 'Filtrovat výběr členů filtry listu',
    TABLE_RELATION: 'Relace tabulky',
    FILTER_DISPLAY: 'Filtrovat zobrazení',
    RELATE_TABLE: 'Propojit s tabulkou',
    USE_BLANKS: 'Použít prázdné hodnoty',
    NO_DATA_TO_DISPLAY: 'Žádná data k zobrazení',
    USE_REFERENCE_SORT: 'Použít jeho řazení',
    USE_REFERENCE_FILTERS: 'Použít jeho filtry',
    USE_REFERENCE_TIMELINE: 'Použít jeho časovou osu',
    USE_REFERENCE_TEMPLATES: 'Použít jeho šablony',
    USE_REFERENCE_ROWS: 'Použít jeho řádky',
    USE_REFERENCE_COLUMNS: 'Použít jeho sloupce',
    REFERENCE_ANOTHER_SHEET: 'Odkázat na jiný list',
    NO_SHEET_SELECTED: 'Žádný list není vybrán',
    SELECT_SHEET: 'Vyberte list',
    SHEET_REFERENCED: 'List úspěšně odkázán',
    CANNOT_ADD_ROWS: 'Nelze přidat řádky při odkazu',
    CANNOT_EDIT_ROWS: 'Nelze upravovat řádky při odkazu',
    CANNOT_EDIT_COLUMNS: 'Nelze upravovat sloupce při odkazu',
    CANNOT_ADD_COLUMNS: 'Nelze přidat sloupce při odkazu',
    CANNOT_ADD_FILTERS: 'Nelze přidat filtry při odkazu',
    REVERSE_DIMENSION: 'reverzně připojená dimenze',
    REMOVE_FROM_RULE: 'Odebrat z pravidla',
    NEW_RULE: 'Nové pravidlo',
    DUPLICATE_RULE: 'Duplikovat pravidlo',
    REMOVE_RULE: 'Odebrat pravidlo',
    ENABLE_RULE: 'Povolit pravidlo',
    DISABLE_RULE: 'Zakázat pravidlo',
    RULE_DISABLED: 'Zakázáno',
    VARIABLE_LOCK_INFO_TITLE: 'Tato proměnná bude používat pouze toto pravidlo.',
    VARIABLE_LOCK_INFO_BODY: 'Ostatní pravidla budou přepsána. Pro zamknutí celé proměnné ponechte sekci dimenzí prázdnou.',
    DELETED: 'Smazáno',
    DONE: 'Hotovo',
    CHOOSE_ITEMS_TO_EXPORT: 'Vyberte položky k exportu',
    UPLOAD_MODEL_FILE: 'Nahrajte soubor modelu',
    NO_FILE_SELECTED: 'Žádný soubor nevybrán',
    BACK: 'Zpět',
    ALLOW_IMPORT_TO: 'Povolit import do',
    FINISHED: 'Dokončeno',
    IMPORT_PREVIEW: 'Toto je náhled změn, které by import provedl s aktuálním nastavením.\n\nZměny:\n',
    IMPORT_FINISHED: 'Import dokončen.\n\nZměny:\n',
    LOADING_MODEL: 'Importování modelu ze souboru...',
    CUSTOM_COLUMN: 'Vlastní sloupec',
    EXPAND_ROW_COLUMN_TOOLBAR: 'Rozbalit panel řádků a sloupců',
    SEARCH_FOR_EXPRESSIONS: 'Hledat funkce, proměnné, dimenze…',
    NEW: 'Nový',
    SELECT_A_CELL: 'Vyberte buňku s hodnotou pro zobrazení vzorce',
    SELECT_A_CELL_TO_EDIT_ROWS: 'Vyberte buňku pro úpravu řádků',
    OR_COLUMNS: 'nebo sloupce',
    MANAGE_PERMISSIONS_FOR: 'Spravovat oprávnění pro „{name}"',
    VIEW_ONLY: 'Pouze pro čtení',
    DATA_EDIT: 'Úprava dat',
    EDIT_OWNED: 'Upravit vlastní',
    FULL_EDIT: 'Plná úprava',
    UNKNOWN_USER: 'Neznámý uživatel',
    UNKNOWN_GROUP: 'Neznámá skupina',
    BUTTON_STYLE: 'Styl tlačítka',
    BUTTON_STYLES: {
        primary: 'Primární',
        secondary: 'Sekundární',
        tertiary: 'Terciární',
        quaternary: 'Kvartérní',
    },
    APP_ICON: 'Ikona aplikace',
    LAST_MODIFIED_BY: 'Naposledy upravil/a {name}',
    LAST_MODIFIED_BY_COLUMN: 'Naposledy upravil/a',
    LAST_MODIFIED_AT_COLUMN: 'Naposledy upraveno',
    SHOW: 'Zobrazit',
    FORMULA_QA: 'Kontrola vzorců',
    TIME_LIMIT: 'Časový limit',
    RESTRICTIONS: 'Omezení',
    SEARCH_FOR_USERS_GROUPS: 'Hledat uživatele nebo skupiny…',
    SEARCH_OR_ADD_USERS_GROUPS: 'Hledat nebo sdílet s uživateli, skupinami nebo veřejně…',
    STATUS_TRACKING: 'Sledování stavu',
    STATUS_TRACKING_MESSAGE: 'Sledování umožňuje uživateli nebo skupině odeslat změny a požádat o vaše schválení.',
    TRACK_STATUS: 'Sledovat stav',
    STOP_TRACKING: 'Zastavit sledování',
    RESTART_TRACKING: 'Znovu spustit sledování',
    ALL: 'Vše',
    TRACKED: 'Sledované',
    UNTRACKED: 'Nesledované',
    ALL_TRACKED: 'Vše sledované',
    MY_TRACKED: 'Moje sledované',
    MY_APPROVALS: 'Moje schválení',
    ALL_SHARES: 'Všechna sdílení',
    SUPER_USERS: 'Superuživatelé',
    LOADING_SUPER_USERS: 'Načítání superuživatelů...',
    CANNOT_EDIT_WHEN_TIME_LIMIT: 'Nelze upravovat, když je časový limit aktivní',
    CANNOT_EDIT_WHEN_TRACKED: 'Nelze upravovat, když je stav sledován',
    EXPORT_SHARES: 'Export sdílení',
    SHARE_COPIED: 'Sdílení zkopírováno!',
    SHARES_COPIED: 'Sdílení zkopírována!',
    COPY_SHARE_IN_FOLDER: 'Kopírovat na vše v této složce',
    COPY_AND_OVERRIDE_SHARES: 'Kopírovat a přepsat sdílení',
    COPY_AND_OVERRIDE_SHARES_CONFIRMATION: 'Všechna existující sdílení na položkách a složkách uvnitř této složky budou nahrazena sdíleními aktuální složky.',
    COPY_ALL_SHARES_IN_FOLDER: 'Kopírovat a přepsat všechna sdílení v této složce',
    GRID_SINGLE_CHART_EXPLANATION: 'Jeden graf s řádky nejvyšší úrovně',
    GRID_MULTIPLE_CHART_EXPLANATION: 'Mřížka malých grafů, jeden pro každý řádek nejvyšší úrovně',
    DUPLICATE_KEYS_FOUND: 'Nalezeny duplicitní klíče',
    DUPLICATE_KEYS_PROMPT: 'Chcete odfiltrovat duplicity a vytvořit pouze unikátní položky?',
    NAMES_SHOULD_BE_UNIQUE: 'Názvy musí být unikátní',
    LIMIT_TO_FILTERED_OPTIONS: 'Omezit na filtrované možnosti',

    // Toast messages
    SWITCHING_TENANT: 'Přepínání pracovního prostoru',
    TENANT_SWITCHED_SUCCESS: 'Pracovní prostor úspěšně přepnut',
    TENANT_SWITCH_FAILED: 'Nepodařilo se načíst nová data pracovního prostoru. Prosím obnovte stránku',
    FAILED_LOAD_MESSAGES: 'Nepodařilo se načíst zprávy',
    NEW_CHAT_CREATED: 'Nový chat vytvořen!',
    FAILED_LOAD_CHATS: 'Nepodařilo se načíst chaty.',
    FAILED_CREATE_CHAT: 'Nepodařilo se vytvořit nový chat.',
    FAILED_SEND_MESSAGE: 'Nepodařilo se vytvořit nový chat nebo odeslat zprávu.',
    FAILED_RENAME_CHAT: 'Nepodařilo se přejmenovat chat.',
    FAILED_DELETE_CHAT: 'Nepodařilo se smazat chat.',
    XLSX_FILE_ONLY: 'Pouze soubory .xlsx',
    JSON_FILE_ONLY: 'Pouze soubory .json',
    EXPORT_DONE: 'Hotovo!',
    LOCKS_SAVED: 'Zámky uloženy',
    COPIED_TO_CLIPBOARD: 'Zkopírováno do schránky',
    INVALID_INTERVAL: 'Neplatný interval',
    SELECT_REQUIRED_DIMENSIONS: 'Vyberte požadované dimenze.',
    ENTITY_TYPE_NOT_SPECIFIED: 'Typ entity není specifikován',

    // Button labels
    OK: 'OK',
    DELETE_ENTITY: 'Smazat entitu',
    SAVE_ENTITY: 'Uložit entitu',
    GENERATED_ENTITIES: 'Generované entity',
    NEW_ENTITY: 'Nová entita',
    ENTITIES: 'Entity',
    SHOW_LOGS: 'Zobrazit protokoly',
    CALCULATE: 'Vypočítat',
    FORMULA_QA_TITLE: 'Kontrola vzorců',
    RENAME_CHAT: 'Přejmenovat chat',
    SEND: 'Odeslat',
    EXPORT_CURRENT_SHEET: 'Exportovat aktuální tabulku',
    TERMINATE: 'Ukončit',
    CONFIRM_UPDATE: 'Potvrdit aktualizaci',

    // Form labels and placeholders
    FROM_DATE: 'Od data',
    TO_DATE: 'Do data',
    AUDIT_TYPE: 'Typ auditu',
    SELECT_AUDIT_TYPE: 'Vyberte typ auditu',
    USER: 'Uživatel',
    PAGE_SIZE: 'Velikost stránky',
    SELECT_PAGE_SIZE: 'Vyberte velikost stránky',
    SELECT_USER: 'Vyberte uživatele',
    EXPORT_EXPANDED_ROWS: 'Exportovat aktuálně rozbalené řádky',
    EXPORT_ALL_ROWS: 'Exportovat všechny řádky',
    EXPORT_FILENAME_LABEL: 'Název',
    EXPORT_VARIABLE: 'Export proměnné',
    EXPORT_FORMAT: 'Formát exportu',
    EXPORT_FORMAT_XLSX: '.xlsx (Excel 2007 a novější)',
    EXPORT_FORMAT_CSV_BOM: '.csv (kompatibilní s Excelem)',
    EXPORT_FORMAT_CSV: '.csv (čistá data)',
    EXPORT_FORMAT_JSON: '.json',
    INCLUDE_MEMBERS: 'Zahrnout členy',
    MESSAGE_FARSEER_AI: 'Zpráva pro FarseerAI...',
    ENTER_NEW_CHAT_NAME: 'Zadejte nový název chatu',
    FLAG: 'Příznak',

    // Chat suggestions
    CHAT_SUGGESTION_SUMMARY: 'Podej mi stručné shrnutí modelu',
    CHAT_SUGGESTION_DIMENSIONS: 'Existují nějaké proměnné, které mají více dimenzí než proměnné použité v jejich vzorci?',
    CHAT_SUGGESTION_DELAY: 'Používají některé proměnné funkci delay()?',
    CHAT_SUGGESTION_ONDEMAND: 'Vypiš všechny proměnné na vyžádání',
    CHAT_SUGGESTION_MEASURES: 'Vypiš všechny míry',
    CHAT_SUGGESTION_FIXED: 'Vypiš všechny proměnné, které používají fixní dimenzi',
    CHAT_SUGGESTION_DATE: 'Vypiš všechny dimenze, které mají vlastnost data',

    // Loading defaults
    DEFAULT_LOADING: 'Načítání...',
    DEFAULT_SUCCESS: 'Úspěch!',

    // Audit logs
    TOTAL_RESULTS: 'Celkem výsledků: {count}',
    PAGE_OF_TOTAL: 'Stránka {current} z {total}',
    DB_ID: 'ID databáze',
    DATE_AND_TIME: 'Datum a čas',
    LOG_TYPE: 'Typ protokolu',
    DATA: 'Data',

    // Entity debugger
    NO_TYPES: 'Žádné typy',

    // Formula QA Modal
    RESULT: 'Výsledek: {value}',
    ENTER_FORMULA_TO_CALCULATE: 'Zadejte vzorec pro výpočet výsledku.',

    // Model export
    EXPORTING_MODEL_ITEMS: 'Export vybraných položek modelu...',

    // Search
    RECENTLY_SEARCHED: 'Nedávno hledané',

    // Compound formulas
    UNPARSEABLE_COMPOUND_FORMULA: 'Tento vzorec je příliš složitý na to, aby mohl být reprezentován jako složená pravidla',

    // Datasets
    DATASET_CURRENT_VERSION: 'Aktuální verze',
    DATASET_NOT_CURRENT_VERSION: 'Není to aktuální verze',
    DATASET_ROW_COUNT: '{rows} {{řádek|řádky}}',
    DATASET_ROWS_WRITTEN: 'Zapsané řádky',
    DATASET_SIZE_WRITTEN: 'Zapsaná velikost',
    DATASET_ROW_COUNT_PREVIEW_LIMITED: '{rows} řádků, zobrazeno prvních {shown}',
    DATASET_PREVIEW_UNSUPPORTED_FORMAT: 'Náhled podporuje verze ve formátu parquet a CSV. Stáhněte si tuto verzi a otevřete ji.',
    DATASET_PREVIEW_TOO_LARGE: 'Tato verze je příliš velká pro náhled. Stáhněte si ji a otevřete ji.',
    DATASET_WRITTEN_BY: 'Zapsal',
    DATASET_OPENED_FROM: 'Otevřeno z',
    DATASET_FROM_OPENED_RUN: 'Zapsáno otevřeným během',
    DATASET_SHOW_CURRENT: 'Zobrazit aktuální',
    DATASET_VERSION_CANCELLED: 'Tato verze byla zrušena a nikdy se nestala aktuální.',
    DATASET_VERSION_CANCELLED_EMPTY: 'Tato verze byla zrušena a nikdy se nestala aktuální. Neobsahuje žádná data.',
    DATASET_VERSION_STILL_WRITING: 'Tato verze se stále zapisuje. Zatím nemá žádná data k náhledu.',
    DATASET_PREVIEW_FIRST_FILE: 'Tato verze obsahuje {count} souborů. Zobrazen je pouze soubor {filename}.',
    DATASET_NO_PUBLISHED_VERSION: 'Zatím žádná data. Tato datová sada nemá publikovanou verzi.',
    DATASET_VERSION_NOT_FOUND: 'Tato verze již neexistuje.',
    DATASET_PREVIEW_FORBIDDEN: 'Nemáte oprávnění ke čtení této datové sady.',
    DATASET_COPY_LOADED_ROWS_ONLY: 'Byly zkopírovány pouze již zobrazené řádky. Stáhněte si soubor, abyste získali všechny řádky.',
    DATASET_NOT_FOUND: 'Datová sada nebyla nalezena nebo není přístupná.',
    GO_BACK_TO_DATASETS: 'Zpět na datové sady',
    OPEN_DATASET: 'Otevřít datovou sadu',
    OPEN_DATASET_VERSION: 'Otevřít tuto verzi',
    DATASETS_LOAD_FAILED: 'Nepodařilo se načíst datasety',
    PIPELINES_LOAD_FAILED: 'Nepodařilo se načíst pipeline',
    PIPELINES_NO_PERMISSION: 'K zobrazení pipeline potřebujete oprávnění „{permission}“.',
    DATASET_DELETE_CONFIRM: 'Smazat dataset {name}? Tím se odstraní všechny jeho verze a tuto akci nelze vrátit zpět.',
    DATASET_VERSION_HISTORY: 'Historie verzí',
    DATASET_VERSION_COUNT: '{count} {{verze|verze}}',
    DATASET_VERSIONS_LOAD_FAILED: 'Nepodařilo se načíst verze',
    DATASET_VERSION_STARTED: 'Spuštěno',
    DATASET_VERSION_PUBLISHED: 'Publikováno',
    DATASET_VERSION_STATUS_MAP: {
        current: 'Aktuální',
        published: 'Publikováno',
        candidate: 'Dokončeno, nepublikováno',
        writing: 'Zapisuje se',
    },
    DATASET_VERSION_CANCELLATION_MAP: {
        manual: 'Zrušeno',
        run_closed: 'Běh skončil před publikováním',
        run_failed: 'Běh selhal',
        validation_failed: 'Validace selhala',
        superseded_by_retry: 'Nahrazeno novějším během',
        publication_conflict: 'Nepublikováno: aktuální verze se během běhu změnila',
        expired: 'Nepublikováno do 24 h',
        legacy_cancelled: 'Zrušeno (před sledováním historie)',
    },
    DATASET_VERSION_PUBLICATION_CONFLICT: 'Nepublikováno: {version} se během běhu stala aktuální verzí',
    DATASET_MAKE_CURRENT: 'Nastavit jako aktuální',
    DATASET_MAKE_CURRENT_TITLE: 'Nastavit {version} jako aktuální?',
    DATASET_MAKE_CURRENT_QUESTION: 'Pozdější čtení datasetu {dataset} budou používat {version}. To zahrnuje kroky Load, další pipeline i náhled. Data, která už model Farseer z tohoto datasetu načetl, se nezmění.',
    DATASET_MAKE_CURRENT_WARNING: 'Běh pipeline, který právě teď zapisuje do tohoto datasetu, selže a jeho nepublikovaná verze bude zrušena. Pokud dataset sleduje svou pozici čtení ve zdroji, pozice se vrátí zpět tam, kde verze {version} skončila.',
    DATASET_MAKE_CURRENT_NO_PERMISSION: 'Ke změně aktuální verze potřebujete oprávnění \'{permission}\'.',
    DATASET_PUBLISH: 'Publikovat',
    DATASET_PUBLISH_TITLE: 'Publikovat {version}?',
    DATASET_PUBLISH_QUESTION: 'Publikováním se verze {version} stane aktuální verzí. Běh její pipeline ji nepublikoval: běh skončil předčasně nebo stále běží.',
    DATASET_PUBLISH_WARNING: 'Publikováním se přeskočí kontroly, které běh provádí před publikováním.',
};

export default {
    ...(baseLanguageValues as Translation),
    ...translationValues,
};
